import store from "./../store/index";
import langMaby from "./language-maby.js";
let langs = [
  {
    key: "密码",
    value: "Password",
  },
  {
    key: "忘记密码",
    value: "Password dimenticata?",
  },
  {
    key: "电子邮件",
    value: "E-mail",
  },
  {
    key: "手机",
    value: "cellulare",
  },
  {
    key: "加入商品库",
    value: "Aggiungi al catalogo",
  },
  {
    key: "请输入邮箱/手机号",
    value: "Inserisci email o numero di cellulare",
  },
  {
    key: "记住密码",
    value: "Ricorda la password",
  },
  {
    key: "新会员注册",
    value: "Registrati",
  },
  {
    key: "请输入密码",
    value: "Inserisci la password",
  },
  {
    key: "手机号码",
    value: "Numero di telefono",
  },
  {
    key: "电子邮箱",
    value: "E-mail",
  },
  {
    key: "其他认证方式",
    value: "Altri metodi di autenticazione",
  },
  {
    key: "请输入手机号",
    value: "Inserisci il numero di telefono",
  },
  {
    key: "验证码获取",
    value: "Ottieni il codice di verifica",
  },
  {
    key: "必填参数缺失",
    value: "Parametri obbligatori mancanti",
  },
  {
    key: "发送",
    value: "Invia",
  },
  {
    key: "事件列表",
    value: "Elenco eventi",
  },
  {
    key: "填写个人信息",
    value: "Compila i tuoi dati",
  },
  {
    key: "完成注册",
    value: "Completa la registrazione",
  },
  {
    key: "姓氏",
    value: "Cognome",
  },
  {
    key: "请输入姓氏",
    value: "Inserisci cognome",
  },
  {
    key: "名字",
    value: "Nome",
  },
  {
    key: "请输入名字",
    value: "Inserisci nome",
  },
  {
    key: "您输入的密码不一致！",
    value: "Le password inserite non corrispondono!",
  },
  {
    key: "请输入有效的邮箱地址",
    value: "Inserisci un indirizzo email valido",
  },
  {
    key: "请输入正确的邮箱地址",
    value: "Inserisci un indirizzo email valido",
  },
  {
    key: "前缀",
    value: "Prefisso",
  },
  {
    key: "输入您的电话号码",
    value: "Inserisci il tuo numero di telefono",
  },
  {
    key: "验证码",
    value: "Codice di verifica",
  },
  {
    key: "手机号为空",
    value: "Il numero di telefono è obbligatorio",
  },
  {
    key: "NIF / DNI",
    value: "NIF / DNI",
  },
  {
    key: "请输入NIF",
    value: "Inserisci NIF",
  },
  {
    key: "RAKUMART的用户协议和隐私政策",
    value: "Termini di utilizzo e Informativa sulla privacy di RAKUMART",
  },
  {
    key: "验证码错误",
    value: "Codice di verifica errato",
  },
  {
    key: "正在进行的订单",
    value: "Ordini in corso",
  },
  {
    key: "关键词",
    value: "Parole chiave",
  },
  {
    key: "图片上传中",
    value: "Caricamento immagine in corso",
  },
  {
    key: "意见反馈",
    value: "Feedback",
  },
  {
    key: "退出登录",
    value: "Esci",
  },
  {
    key: "法律声明",
    value: "Note legali",
  },
  {
    key: "法律申明",
    value: "Note legali",
  },
  {
    key: "注册",
    value: "Registrati",
  },
  {
    key: "购物车",
    value: "Carrello",
  },
  {
    key: "为您推荐",
    value: "Consigliati per te",
  },
  {
    key: "常见问题",
    value: "Domande frequenti",
  },
  {
    key: "我们是谁",
    value: "Chi siamo",
  },
  {
    key: "会员等级",
    value: "Commissione",
  },
  {
    key: "手续费比例",
    value: "Percentuale di commissione",
  },
  {
    key: "查看相似",
    value: "Vedi simili",
  },
  {
    key: "已售",
    value: "Venduti",
  },
  {
    key: "件",
    value: "pezzi",
  },
  {
    key: "等待财务确认",
    value: "In attesa di conferma pagamento",
  },
  {
    key: "首页",
    value: "Home",
  },
  {
    key: "加入购物车",
    value: "Aggiungi al carrello",
  },
  {
    key: "总计",
    value: "Totale",
  },
  {
    key: "在库数",
    value: "Disponibilità",
  },
  {
    key: "购物车添加成功",
    value: "Aggiunto al carrello",
  },
  {
    key: "收藏商品",
    value: "Prodotti preferiti",
  },
  {
    key: "常购商品管理",
    value: "Gestione articoli frequenti",
  },
  {
    key: "收藏店铺",
    value: "Segui il negozio",
  },
  {
    key: "国家",
    value: "Paese",
  },
  {
    key: "输入验证码",
    value: "Inserisci il codice",
  },
  {
    key: "获得代码",
    value: "Ricevi il codice",
  },
  {
    key: "用户协议和隐私政策",
    value: "Termini di utilizzo e Informativa sulla privacy",
  },
  {
    key: "已被使用",
    value: "Già utilizzato",
  },
  {
    key: "格式不正确",
    value: "Formato non corretto",
  },
  {
    key: "电话格式不正确",
    value: "Formato del numero di telefono non corretto",
  },
  {
    key: "找不到你想要的吗？",
    value: "Non trovi quello che cerchi?",
  },
  {
    key: "我们的搜索引擎会自动翻译成中文以进行搜索。",
    value:
      "Il nostro motore di ricerca traduce automaticamente in cinese per effettuare la ricerca.",
  },
  {
    key: "你输入的关键词翻译可能不正确。",
    value:
      "La traduzione delle parole chiave inserite potrebbe non essere corretta.",
  },
  {
    key: "如果你需要帮助寻找所需产品，请直接联系我们。",
    value:
      "Se hai bisogno di aiuto, contatta un agente esperto tramite Rakuchat o WhatsApp",
  },
  {
    key: "与代理聊天",
    value: "Chatta con un agente",
  },
  {
    key: "最佳选择",
    value: "Migliore scelta",
  },
  {
    key: "个人中心",
    value: "Area personale",
  },
  {
    key: "登录",
    value: "Accedi",
  },
  {
    key: "附加服务说明",
    value: "Informazioni servizi aggiuntivi",
  },
  {
    key: "取消收藏",
    value: "Rimuovi dai preferiti",
  },
  {
    key: "商品详情",
    value: "Dettagli prodotto",
  },
  {
    key: "商品推荐",
    value: "Prodotti consigliati",
  },
  {
    key: "属性",
    value: "Caratteristiche",
  },
  {
    key: "数量",
    value: "Quantità",
  },
  {
    key: "总价",
    value: "Totale",
  },
  {
    key: "选定的产品",
    value: "Prodotti selezionati",
  },
  {
    key: "产品及运输",
    value: "Prodotti e spedizione",
  },
  {
    key: "只有产品",
    value: "Solo prodotto",
  },
  {
    key: "预估国际费用",
    value: "Costi internazionali stimati",
  },
  {
    key: "结算",
    value: "Procedi al pagamento",
  },
  {
    key: "将该商品将移出购物车",
    value: "Il prodotto verrà rimosso dal carrello",
  },
  {
    key: "确认",
    value: "Conferma",
  },
  {
    key: "取消",
    value: "Annulla",
  },
  {
    key: "是否将选中的商品移除购物车",
    value: "Rimuovere i prodotti selezionati dal carrello?",
  },
  {
    key: "未选择操作的商品",
    value: "Nessun prodotto selezionato",
  },
  {
    key: "保存成功",
    value: "Salvato con successo",
  },
  {
    key: "去购物",
    value: "Inizia gli acquisti",
  },
  {
    key: "更改头像",
    value: "Cambia immagine profilo",
  },
  {
    key: "头像上传中",
    value: "Caricamento immagine in corso",
  },
  {
    key: "张",
    value: "pz",
  },
  {
    key: "账户余额",
    value: "Saldo account",
  },
  {
    key: "手续费",
    value: "Commissione",
  },
  {
    key: "会员等级",
    value: "Commissione",
  },
  {
    key: "提交订单",
    value: "Invia ordine",
  },
  {
    key: "待发货",
    value: "In attesa di spedizione",
  },
  {
    key: "待装仓",
    value: "In attesa di spedizione",
  },
  {
    key: "待付款",
    value: "In attesa di pagamento",
  },
  {
    key: "国际派送中",
    value: "Spedizione internazionale in corso",
  },
  {
    key: "我的券包",
    value: "I miei coupon",
  },
  {
    key: "使用记录",
    value: "Cronologia utilizzo",
  },
  {
    key: "请选择",
    value: "Seleziona",
  },
  {
    key: "请输入内容",
    value: "Inserisci il contenuto",
  },
  {
    key: "券编码",
    value: "Codice coupon",
  },
  {
    key: "券类别",
    value: "Tipo di coupon",
  },
  {
    key: "修改要求",
    value: "Richiesta di modifica",
  },
  {
    key: "额度/可使用次数",
    value: "Importo / Numero di utilizzi",
  },
  {
    key: "有效日期",
    value: "Data di scadenza",
  },
  {
    key: "使用日期",
    value: "Data di utilizzo",
  },
  {
    key: "使用状态",
    value: "Stato di utilizzo",
  },
  {
    key: "行动",
    value: "Azione",
  },
  {
    key: "订单详情",
    value: "Dettagli dell'ordine",
  },
  {
    key: "订单号",
    value: "Numero ordine",
  },
  {
    key: "订单管理",
    value: "Gestione ordini",
  },
  {
    key: "运输中的订单",
    value: "Ordini in transito",
  },
  {
    key: "问题产品",
    value: "Prodotti difettosi",
  },
  {
    key: "附加的服务",
    value: "Servizi aggiuntivi",
  },
  {
    key: "充值",
    value: "Ricarica",
  },
  {
    key: "支付账单",
    value: "Pagamento fattura",
  },
  {
    key: "收藏",
    value: "Preferiti",
  },
  {
    key: "产品",
    value: "Prodotto",
  },
  {
    key: "运输中",
    value: "In transito",
  },
  {
    key: "欧盟内部交付",
    value: "Consegna intra-UE",
  },
  {
    key: "个人资料管理",
    value: "Gestione profilo",
  },
  {
    key: "支付页面收货地址",
    value: "Indirizzo di consegna (pagamento)",
  },
  {
    key: "订单草稿",
    value: "Ordini in bozza",
  },
  {
    key: "报价中",
    value: "In fase di preventivo",
  },
  {
    key: "等待报价",
    value: "In attesa di preventivo",
  },
  {
    key: "等待付款",
    value: "In attesa di pagamento",
  },
  {
    key: "入金确认中",
    value: "Conferma pagamento in corso",
  },
  {
    key: "正在购买",
    value: "Acquisto in corso",
  },
  {
    key: "购买完成",
    value: "Acquisto completato",
  },
  {
    key: "订单已取消",
    value: "Ordine annullato",
  },
  {
    key: "请输入关键词搜索",
    value: "Inserisci parola chiave per la ricerca",
  },
  {
    key: "起始日期",
    value: "Data di inizio",
  },
  {
    key: "至",
    value: "a",
  },
  {
    key: "结束日期",
    value: "Data di fine",
  },
  {
    key: "搜索",
    value: "Cerca",
  },
  {
    key: "导出电子表格",
    value: "Esporta Excel",
  },
  {
    key: "检品中",
    value: "In fase di controllo qualità",
  },
  {
    key: "在RAKUMART仓库中",
    value: "Nel magazzino RAKUMART",
  },
  {
    key: "订单状态",
    value: "Stato ordine",
  },
  {
    key: "操作",
    value: "Azioni",
  },
  {
    key: "Packinglist状态",
    value: "Stato della Packing List",
  },
  {
    key: "物流状态",
    value: "Stato della Packing List",
  },
  {
    key: "注意：如果您想更改交货订单，请与我们联系。",
    value: "Nota: per modificare l’ordine di consegna, contattaci",
  },
  {
    key: "交货订单",
    value: "Ordine di consegna",
  },
  {
    key: "Packinglist",
    value: "Packinglist",
  },
  {
    key: "下单时间",
    value: "Data ordine",
  },
  {
    key: "付款日期",
    value: "Data pagamento",
  },
  {
    key: "等待处理",
    value: "In attesa di elaborazione",
  },
  {
    key: "处理中",
    value: "In elaborazione",
  },
  {
    key: "已入库",
    value: "Ricevuto in magazzino",
  },
  {
    key: "已完成",
    value: "Completato",
  },
  {
    key: "历史问题",
    value: "Problemi passati",
  },
  {
    key: "输入物流号",
    value: "Inserisci il numero di spedizione",
  },
  {
    key: "输入追踪号码",
    value: "Inserisci il numero di spedizione",
  },
  {
    key: "请输入商品详情页链接",
    value: "Si prega di inserire il link della pagina del prodotto",
  },
  {
    key: "请输入1688编号或链接",
    value: "Inserisci ID 1688 o link",
  },
  {
    key: "明白",
    value: "Ho capito",
  },
  {
    key: "联系负责人",
    value: "Contatta il responsabile",
  },
  {
    key: "问题提出日期",
    value: "Data segnalazione",
  },
  {
    key: "问题条数",
    value: "Numero problemi",
  },
  {
    key: "问题商品数量",
    value: "Quantità prodotti problematici",
  },
  {
    key: "暂无数据",
    value: "Nessun dato disponibile",
  },
  {
    key: "问题详情",
    value: "Dettagli problema",
  },
  {
    key: "处理意见",
    value: "Note di gestione",
  },
  {
    key: "统一回复",
    value: "Rispondi a tutti",
  },
  {
    key: "请输入处理意见",
    value: "Inserisci note di gestione",
  },
  {
    key: "全部",
    value: "Tutto",
  },
  {
    key: "移出收藏夹成功",
    value: "Rimosso dai preferiti con successo",
  },
  {
    key: "照片",
    value: "Foto",
  },
  {
    key: "小计",
    value: "Subtotale",
  },
  {
    key: "国内运费",
    value: "Spedizione nazionale",
  },
  {
    key: "备注栏",
    value: "Note",
  },
  {
    key: "问题图像",
    value: "Immagini del problema",
  },
  {
    key: "评论",
    value: "Commenti",
  },
  {
    key: "状态",
    value: "Stato",
  },
  {
    key: "回到首页",
    value: "Torna alla home",
  },
  {
    key: "提出配送单",
    value: "Crea ordine di spedizione",
  },
  {
    key: "单位",
    value: "Unità",
  },
  {
    key: "重量（千克）",
    value: "Peso (kg)",
  },
  {
    key: "已送达",
    value: "Ricevuto",
  },
  {
    key: "已签收",
    value: "Consegnato",
  },
  {
    key: "已收货",
    value: "Ricevuto",
  },
  {
    key: "配送单号",
    value: "Numero spedizione",
  },
  {
    key: "通关方式",
    value: "Modalità di sdoganamento",
  },
  {
    key: "国际运输方式",
    value: "Metodo di trasporto internazionale",
  },
  {
    key: "箱数",
    value: "Numero colli",
  },
  {
    key: "体积",
    value: "Volume",
  },
  {
    key: "银行账户",
    value: "Conto bancario",
  },
  {
    key: "汇款日期",
    value: "Data bonifico",
  },
  {
    key: "汇款日期不能为空",
    value: "La data del bonifico è obbligatoria",
  },
  {
    key: "选择日期",
    value: "Seleziona la data",
  },
  {
    key: "汇款人",
    value: "Mittente del bonifico",
  },
  {
    key: "汇款人不能为空",
    value: "Il mittente è obbligatorio",
  },
  {
    key: "汇款金额",
    value: "Importo bonifico",
  },
  {
    key: "汇款金额不能为空",
    value: "L’importo è obbligatorio",
  },
  {
    key: "备注不能为空",
    value: "Le note sono obbligatorie",
  },
  {
    key: "汇款截图",
    value: "Ricevuta bonifico",
  },
  {
    key: "支付",
    value: "Paga",
  },
  {
    key: "支付方式",
    value: "Metodo di pagamento",
  },
  {
    key: "发票号",
    value: "Numero fattura",
  },
  {
    key: "总金额",
    value: "Totale",
  },
  {
    key: "明细",
    value: "Dettagli",
  },
  {
    key: "下载",
    value: "Scarica",
  },
  {
    key: "关闭",
    value: "Chiudi",
  },
  {
    key: "是否删除选中的商品",
    value: "Rimuovire i prodotti selezionati?",
  },
  {
    key: "请至少选择一项",
    value: "Seleziona almeno un elemento",
  },
  {
    key: "选择",
    value: "Seleziona",
  },
  {
    key: "商品链接",
    value: "Link prodotto",
  },
  {
    key: "产品属性",
    value: "Caratteristiche prodotto",
  },
  {
    key: "单价",
    value: "Prezzo unitario",
  },
  {
    key: "商品状态",
    value: "Stato prodotto",
  },
  {
    key: "正常",
    value: "Normale",
  },
  {
    key: "请输入备注",
    value: "Inserisci note",
  },
  {
    key: "添加",
    value: "Aggiungi",
  },
  {
    key: "店铺名称",
    value: "Nome negozio",
  },
  {
    key: "选中移出",
    value: "Rimuovi selezionati",
  },
  {
    key: "取消替换",
    value: "Annulla sostituzione",
  },
  {
    key: "是否删除此店铺",
    value: "Rimuovire questo negozio?",
  },
  {
    key: "提示",
    value: "Avviso",
  },
  {
    key: "请至少选择一个商品",
    value: "Seleziona almeno un prodotto",
  },
  {
    key: "商品库提出订单",
    value: "Crea ordine dal catalogo",
  },
  {
    key: "商品库添加商品",
    value: "Aggiungi prodotto al catalogo",
  },
  {
    key: "商品图片",
    value: "Immagine prodotto",
  },
  {
    key: "商品属性",
    value: "Caratteristiche prodotto",
  },
  {
    key: "添加一行",
    value: "Aggiungi riga",
  },
  {
    key: "请输入商品链接",
    value: "Inserisci link prodotto",
  },
  {
    key: "保存草稿",
    value: "Salva bozza",
  },
  {
    key: "保存",
    value: "Salva",
  },
  {
    key: "保存中",
    value: "Salvataggio in corso",
  },
  {
    key: "当前默认地址",
    value: "Indirizzo predefinito",
  },
  {
    key: "默认购买人",
    value: "Acquirente predefinito",
  },
  {
    key: "默认",
    value: "Predefinito",
  },
  {
    key: "同步到进口商",
    value: "Sincronizza con importatore",
  },
  {
    key: "保存成功",
    value: "Salvato con successo",
  },
  {
    key: "编辑",
    value: "Modifica",
  },
  {
    key: "这是你的控制面板",
    value: "Questo è il tuo pannello di controllo",
  },
  {
    key: "你好",
    value: "Ciao",
  },
  {
    key: "新消息",
    value: "Nuovi messaggi",
  },
  {
    key: "草稿订单",
    value: "Ordini in bozza",
  },
  {
    key: "预购订单",
    value: "Ordini in preordine",
  },
  {
    key: "从",
    value: "Da",
  },
  {
    key: "起",
    value: "a partire da",
  },
  {
    key: "待供应商发货",
    value: "In attesa di spedizione dal fornitore",
  },
  {
    key: "上架入库完成",
    value: "Ricezione e stoccaggio completati",
  },
  {
    key: "质检中",
    value: "Controllo qualità",
  },
  {
    key: "运费核算中",
    value: "Calcolo spedizione in corso",
  },
  {
    key: "国际运费待支付",
    value: "Spedizione internazionale da pagare",
  },
  {
    key: "运往欧洲途中",
    value: "In transito per l'Europa",
  },
  {
    key: "中国至意大利物流",
    value: "In transito per l'Europa",
  },
  {
    key: "欧盟境内派送中",
    value: "In transito nell'UE",
  },
  {
    key: "已入意大利仓",
    value: "In transito nell'UE",
  },
  {
    key: "意大利境内派送中",
    value: "In consegna in Italia",
  },
  {
    key: "意大利派送中",
    value: "In consegna in Italia",
  },
  {
    key: "已上架订单数",
    value: "Ordini pubblicati",
  },
  {
    key: "需要付款的订单",
    value: "Ordini da pagare",
  },
  {
    key: "需要付款的配送单",
    value: "Spedizioni da pagare",
  },
  {
    key: "国际运费待报价",
    value: "Preventivo spedizione in attesa",
  },
  {
    key: "待报价订单",
    value: "In attesa di preventivo",
  },
  {
    key: "订单到达RAKUMART仓库",
    value: "Ordine arrivato al magazzino RAKUMART",
  },
  {
    key: "待出货订单",
    value: "Ordini da spedire",
  },
  {
    key: "订单运输中",
    value: "Ordine in transito",
  },
  {
    key: "物流与运输",
    value: "Logistica e spedizioni",
  },
  {
    key: "已完成订单",
    value: "Ordini completati",
  },
  {
    key: "发票",
    value: "Fattura",
  },
  {
    key: "历史发票",
    value: "Storico fatture",
  },
  {
    key: "进口方资料",
    value: "Dettagli dell'importatore",
  },
  {
    key: "收藏的供应商",
    value: "Fornitori seguiti",
  },
  {
    key: "密码管理",
    value: "Gestione password",
  },
  {
    key: "账户信息摘要",
    value: "Riepilogo account",
  },
  {
    key: "手续费是如何计算的？",
    value: "Come viene calcolata la commissione?",
  },
  {
    key: "优惠券",
    value: "Coupon",
  },
  {
    key: "重点订单信息",
    value: "Informazioni ordine principali",
  },
  {
    key: "管理",
    value: "Gestione",
  },
  {
    key: "订单进程",
    value: "Stato ordine",
  },
  {
    key: "意大利运输中的订单",
    value: "Ordini in transito in Italia",
  },
  {
    key: "所有订单",
    value: "Tutti gli ordini",
  },
  {
    key: "待收货",
    value: "In attesa di consegna",
  },
  {
    key: "收件人",
    value: "Destinatario",
  },
  {
    key: "进口商",
    value: "Importatore",
  },
  {
    key: "邮编",
    value: "CAP",
  },
  {
    key: "省份",
    value: "Provincia",
  },
  {
    key: "输入你的省份",
    value: "Inserisci la provincia",
  },
  {
    key: "联系人",
    value: "Contatto",
  },
  {
    key: "新增地址",
    value: "Aggiungi indirizzo",
  },
  {
    key: "编辑地址",
    value: "Modifica indirizzo",
  },
  {
    key: "是否默认",
    value: "Imposta come predefinito",
  },
  {
    key: "是否删除当前地址",
    value: "Rimuovire questo indirizzo?",
  },
  {
    key: "不保存更改就退出?",
    value: "Uscire senza salvare le modifiche?",
  },
  {
    key: "删除取消",
    value: "Annulla eliminazione",
  },
  {
    key: "操作成功",
    value: "Operazione riuscita",
  },
  {
    key: "移除成功",
    value: "Rimosso con successo",
  },
  {
    key: "重置",
    value: "Reimposta",
  },
  {
    key: "新增",
    value: "Aggiungi",
  },
  {
    key: "请选择认证方式",
    value: "Seleziona metodo di verifica",
  },
  {
    key: "找回你的密码",
    value: "Recupera la tua password",
  },
  {
    key: "恢复或更改密码",
    value: "Reimposta o cambia password",
  },
  {
    key: "电子邮件链接到您的帐户",
    value: "Email collegata al tuo account",
  },
  {
    key: "你的Rakumart账户的手机号码",
    value: "Numero di telefono del tuo account Rakumart",
  },
  {
    key: "为了保护您的账户，Rakumart希望验证您是试图恢复或更改密码的人",
    value:
      "Per proteggere il tuo account, Rakumart richiede la verifica della tua identità.",
  },
  {
    key: "密码验证",
    value: "Verifica password",
  },
  {
    key: "身份确认",
    value: "Verifica identità",
  },
  {
    key: "请输入登录密码",
    value: "Inserisci la password di accesso",
  },
  {
    key: "密码错误",
    value: "Password errata",
  },
  {
    key: "登录密码修改",
    value: "Modifica password di accesso",
  },
  {
    key: "新密码",
    value: "Nuova password",
  },
  {
    key: "您已经有了新密码，请重新登录。",
    value: "Password aggiornata, effettua nuovamente l’accesso",
  },
  {
    key: "密码修改成功",
    value: "Password modificata con successo",
  },
  {
    key: "购买数量不能超过在库数量",
    value: "La quantità non può superare la disponibilità",
  },
  {
    key: "再次确认密码",
    value: "Conferma password",
  },
  {
    key: "请再次输入密码",
    value: "Inserisci nuovamente la password",
  },
  {
    key: "返回主页",
    value: "Torna alla home",
  },
  {
    key: "更改成功",
    value: "Modifica riuscita",
  },
  {
    key: "登录密码更改成功",
    value: "Password di accesso modificata con successo",
  },
  {
    key: "业务类型",
    value: "Categoria business",
  },
  {
    key: "券",
    value: "Coupon",
  },
  {
    key: "已取消",
    value: "Annullato",
  },
  {
    key: "已取消订单",
    value: "Ordini annullati",
  },
  {
    key: "电话",
    value: "Telefono",
  },
  {
    key: "下一步",
    value: "Continua",
  },
  {
    key: "邮箱",
    value: "Email",
  },
  {
    key: "时间",
    value: "Tempo",
  },
  {
    key: "全选",
    value: "Seleziona tutto",
  },
  {
    key: "详情",
    value: "Dettagli",
  },
  {
    key: "查看详情",
    value: "Visualizza dettagli",
  },
  {
    key: "如果程序是由Rakumart执行的，则将收取“SKU标签”服务费用。",
    value:
      "Se eseguito da Rakumart, verrà addebitato il Servizio di etichettatura SKU",
  },
  {
    key: "亚马逊FBA的标签是免费的，只要程序是由制造商负责。",
    value: "Le etichette Amazon FBA sono gratuite se gestite dal produttore",
  },
  {
    key: "标签为亚马逊FBA",
    value: "Etichetta Amazon FBA",
  },
  {
    key: "亚马逊FBA套装包装",
    value: "Packaging Kit FBA",
  },
  {
    key: "为亚马逊FBA免费打包产品，只要程序由制造商负责。",
    value: "Imballaggio gratuito per Amazon FBA se gestito dal produttore",
  },
  {
    key: "如果该程序是由Rakumart执行的，则将收取“捆绑”服务费用。",
    value: "Se eseguito da Rakumart, verrà addebitato il servizio bundling",
  },
  {
    key: "备注",
    value: "Note",
  },
  {
    key: "店铺",
    value: "Negozio",
  },
  {
    key: "从购物车中导入更多产品",
    value: "Importa più prodotti dal carrello",
  },
  {
    key: "删除",
    value: "Elimina",
  },
  {
    key: "总运费",
    value: "Spedizione totale",
  },
  {
    key: "其他费用",
    value: "Altri costi",
  },
  {
    key: "预计费用",
    value: "Costo stimato",
  },
  {
    key: "预估总计（元）",
    value: "Totale stimato (¥)",
  },
  {
    key: "合计约为（元）",
    value: "Totale stimato (¥)",
  },
  {
    key: "确定",
    value: "Conferma",
  },
  {
    key: "附加服务选择",
    value: "Selezione servizi aggiuntivi",
  },
  {
    key: "购物车为空",
    value: "Carrello vuoto",
  },
  {
    key: "收藏夹",
    value: "Preferiti",
  },
  {
    key: "追加",
    value: "Aggiungi",
  },
  {
    key: "调查在库数量",
    value: "Verifica disponibilità",
  },
  {
    key: "执行券",
    value: "Applica coupon",
  },
  {
    key: "可用优惠券",
    value: "Coupon disponibili",
  },
  {
    key: "重新提出",
    value: "Riprova",
  },
  {
    key: "选择优惠券或代金券",
    value: "Seleziona coupon o voucher",
  },
  {
    key: "代金券",
    value: "Voucher",
  },
  {
    key: "编号",
    value: "Codice",
  },
  {
    key: "已取消支付",
    value: "Pagamento annullato",
  },
  {
    key: "请上传图片",
    value: "Carica immagine",
  },
  {
    key: "是否使用银行卡支付",
    value: "Pagare con carta bancaria?",
  },
  {
    key: "汇款金额不能小于最低汇款金额",
    value: "L'importo non può essere inferiore al minimo",
  },
  {
    key: "产品价值",
    value: "Valore prodotto",
  },
  {
    key: "附加服务",
    value: "Servizi aggiuntivi",
  },
  {
    key: "关税",
    value: "Dazi doganali",
  },
  {
    key: "运货方式",
    value: "Modalità di spedizione",
  },
  {
    key: "优惠金额",
    value: "Sconto",
  },
  {
    key: "实际支付金额",
    value: "Importo pagato",
  },
  {
    key: "展开",
    value: "Distribuzione",
  },
  {
    key: "导入的详细信息",
    value: "Dettagli importazione",
  },
  {
    key: "前往登录",
    value: "Vai al login",
  },
  {
    key: "用户指南",
    value: "Guida rapida",
  },
  {
    key: "常见问题解答",
    value: "FAQ",
  },
  {
    key: "国际运费",
    value: "Spese di spedizione internazionale",
  },
  {
    key: "加载中",
    value: "Caricamento",
  },
  {
    key: "共",
    value: "Totale",
  },
  {
    key: "衣服",
    value: "Abbigliamento",
  },
  {
    key: "商品种类",
    value: "Articoli",
  },
  {
    key: "数量总计",
    value: "Quantità totale",
  },
  {
    key: "海上运输",
    value: "Trasporto marittimo",
  },
  {
    key: "操作菜单",
    value: "Menu operazioni",
  },
  {
    key: "暂无优惠券",
    value: "Nessun coupon disponibile",
  },
  {
    key: "欧元",
    value: "Euro",
  },
  {
    key: "无佣金",
    value: "Zero commissioni",
  },
  {
    key: "商品价值",
    value: "Valore prodotto",
  },
  {
    key: "问题图片",
    value: "Immagini problema",
  },
  {
    key: "问题商品明细",
    value: "Dettagli prodotto problematico",
  },
  {
    key: "添加选中商品",
    value: "Aggiungi prodotti selezionati",
  },
  {
    key: "名称",
    value: "Nome",
  },
  {
    key: "收货地址",
    value: "Indirizzo di spedizione",
  },
  {
    key: "收件公司",
    value: "Azienda destinataria",
  },
  {
    key: "请输入收件公司",
    value: "Inserisci azienda destinataria",
  },
  {
    key: "请输入邮编",
    value: "Inserisci CAP",
  },
  {
    key: "请输入地址",
    value: "Inserisci indirizzo",
  },
  {
    key: "请输入联系人",
    value: "Inserisci contatto",
  },
  {
    key: "请输入手机",
    value: "Inserisci numero di telefono",
  },
  {
    key: "请输入电话",
    value: "Inserisci telefono",
  },
  {
    key: "请输入电子邮箱",
    value: "Inserisci email",
  },
  {
    key: "收货地址详情",
    value: "Indirizzo completo",
  },
  {
    key: "RAKUMART代通关",
    value: "Sdoganamento tramite RAKUMART",
  },
  {
    key: "个人通关",
    value: "Sdoganamento privato",
  },
  {
    key: "意大利物流费用",
    value: "Costi logistici in Italia",
  },
  {
    key: "增值税",
    value: "IVA",
  },
  {
    key: "修改姓氏",
    value: "Modifica Cognome",
  },
  {
    key: "修改唛头",
    value: "Modifica etichetta",
  },
  {
    key: "修改名字",
    value: "Modifica nome",
  },
  {
    key: "修改NIF",
    value: "Modifica NIF",
  },
  {
    key: "基本信息",
    value: "Informazioni di base",
  },
  {
    key: "修改",
    value: "Modifica",
  },
  {
    key: "此项为必填项",
    value: "Campo obbligatorio",
  },
  {
    key: "不能为空",
    value: "Campo obbligatorio",
  },
  {
    key: "请上传支付截图",
    value: "Carica ricevuta pagamento",
  },
  {
    key: "请输入邮箱",
    value: "Inserisci email",
  },
  {
    key: "使用条款和隐私政策还没有被同意。",
    value: "Accetta i Termini e l'Informativa sulla Privacy",
  },
  {
    key: "物流单号",
    value: "Numero tracking",
  },
  {
    key: "前往付款",
    value: "Vai al pagamento",
  },
  {
    key: "请选择预设收货地址",
    value: "Seleziona indirizzo predefinito",
  },
  {
    key: "操作失败",
    value: "Operazione non riuscita",
  },
  {
    key: "浏览器已拦截页面跳转，请允许本站跳转后重试",
    value:
      "Il browser ha bloccato il reindirizzamento. Consenti la navigazione per questo sito e riprova.",
  },
  {
    key: "邮箱、手机号或密码输入错误",
    value: "Email, telefono o password errati",
  },
  {
    key: "销量",
    value: "Vendite",
  },
  {
    key: "是否登录",
    value: "Accesso effettuato?",
  },
  {
    key: "Rakumart是一个批发进口平台，不提供零售服务。",
    value:
      "Rakumart è una piattaforma d'ingrosso per l'importazione e non offre servizi di vendita al dettaglio",
  },
  {
    key: "与代理交谈",
    value: "Parla con un consulente",
  },
  {
    key: "是否前往登录?",
    value: "Vuoi andare al login?",
  },
  {
    key: "请选择预设进口商",
    value: "Seleziona un importatore predefinito",
  },
  {
    key:
      "没有搜索到您想要的商品，您可以尝试通过图片搜索。或者直接通过WhatsApp或者邮件联系我们。我们会帮您寻找合适的供应商。",
    value:
      "Non siamo riusciti a trovare il prodotto che cercavi. Puoi provare a cercare tramite immagine oppure contattarci direttamente via WhatsApp o e-mail. Ti aiuteremo a trovare un fornitore adatto.",
  },
  {
    key: "返回首页",
    value: "Torna alla Home",
  },
  {
    key: "是否确认删除？",
    value: "Confermare l'eliminazione?",
  },
  {
    key: "已使用优惠券",
    value: "Coupon utilizzato",
  },
  {
    key: "已使用代金券",
    value: "Voucher utilizzato",
  },
  {
    key: "意大利物流",
    value: "Logistica in Italia",
  },
  {
    key: "rakumart代通关",
    value: "Sdoganamento tramite Rakumart",
  },
  {
    key: "未达到使用条件",
    value: "Condizioni di utilizzo non soddisfatte",
  },
  {
    key: "订单已删除",
    value: "Ordine eliminato",
  },
  {
    key: "已使用",
    value: "Utilizzato",
  },
  {
    key: "电子邮箱修改",
    value: "Modifica email",
  },
  {
    key: "手机号修改",
    value: "Modifica numero di telefono",
  },
  {
    key: "手机号输入错误",
    value: "Numero di telefono non valido",
  },
  {
    key: "地址",
    value: "Indirizzo",
  },
  {
    key: "购买方",
    value: "Parte acquirente",
  },
  {
    key: "付款",
    value: "Pagamento",
  },
  {
    key: "总体积",
    value: "Volume totale",
  },
  {
    key: "个人资料",
    value: "Profilo personale",
  },
  {
    key: "个产品",
    value: "prodotti",
  },
  {
    key: "常用商品管理",
    value: "Gestione acquisti abituali",
  },
  {
    key: "反倾销税",
    value: "Dazio antidumping",
  },
  {
    key: "如地段价格显示不正确，报价完成后会更正。",
    value:
      "Se il prezzo visualizzato non è corretto, verrà corretto dopo il preventivo.",
  },
  {
    key: "展开更多",
    value: "Mostra altro",
  },
  {
    key: "信息未保存，是否确认退出",
    value: "Le informazioni non sono state salvate. Vuoi uscire?",
  },
  {
    key: "信息未保存，确认退出吗？",
    value: "Modifiche non salvate. Uscire?",
  },
  {
    key: "发送方式",
    value: "Metodo di invio",
  },
  {
    key: "签收时间",
    value: "Data di consegna",
  },
  {
    key: "海关",
    value: "Dogana",
  },
  {
    key: "邮箱更改成功",
    value: "Email aggiornata correttamente",
  },
  {
    key: "点击选择附加服务",
    value: "Clicca per selezionare servizi aggiuntivi",
  },
  {
    key: "您可以在这边添加商品备注",
    value: "Puoi aggiungere qui note sul prodotto",
  },
  {
    key: "该订单已成功支付",
    value: "Ordine pagato con successo",
  },
  {
    key: "同意",
    value: "Accetta",
  },
  {
    key: "已过期",
    value: "Scaduto",
  },
  {
    key: "有效期",
    value: "Periodo di validità",
  },
  {
    key: "今日到期",
    value: "Scade oggi",
  },
  {
    key: "订单金额",
    value: "Totale ordine",
  },
  {
    key: "请输入6-16位包含大小写字母和数字的字符串",
    value: "Inserisci 6-16 caratteri con lettere maiuscole, minuscole e numeri",
  },
  {
    key: "提出配送单请将地址填写完整",
    value: "Completa l'indirizzo per creare la spedizione",
  },
  {
    key: "提出数不能超过可提出数",
    value: "La quantità richiesta non può superare quella disponibile",
  },
  {
    key: "此店铺暂无商品",
    value: "Questo negozio non ha prodotti disponibili",
  },
  {
    key: "选择通关方式",
    value: "Seleziona modalità di sdoganamento",
  },
  {
    key: "立即生成",
    value: "Genera ora",
  },
  {
    key: "付款成功",
    value: "Pagamento riuscito",
  },
  {
    key: "描述",
    value: "Descrizione",
  },
  {
    key: "发送时间",
    value: "Ora di invio",
  },
  {
    key: "接待时间",
    value: "Orario di ricezione",
  },
  {
    key: "是否取消选中的订单",
    value: "Annullare gli ordini selezionati?",
  },
  {
    key: "是否签收选中的商品？",
    value: "Confermare la ricezione dei prodotti selezionati?",
  },
  {
    key: "签收成功",
    value: "Ricezione confermata",
  },
  {
    key: "手机号更改成功",
    value: "Numero aggiornato con successo",
  },
  {
    key: "加入商品库成功",
    value: "Prodotto aggiunto al catalogo",
  },
  {
    key: "商品库为空",
    value: "Catalogo prodotti vuoto",
  },
  {
    key: "已取消签收",
    value: "Ricezione annullata",
  },
  {
    key: "查看更多",
    value: "Vedi altro",
  },
  {
    key: "订单付款",
    value: "Pagamento ordine",
  },
  {
    key: "全部通知",
    value: "Tutte le notifiche",
  },
  {
    key: "已读",
    value: "Letto",
  },
  {
    key: "未读",
    value: "Non letto",
  },
  {
    key: "通知",
    value: "Notifiche",
  },
  {
    key: "是否确认删除选中的通知",
    value: "Eliminare le notifiche selezionate?",
  },
  {
    key: "删除提示",
    value: "Avviso eliminazione",
  },
  {
    key: "网站缓存（Cookie）政策",
    value: "Informativa sui cookie",
  },
  {
    key: "Cookie 政策",
    value: "Informativa sui cookie",
  },
  {
    key: "通用条款",
    value: "Condizioni generali",
  },
  {
    key: "Rakumart 服务条款",
    value: "Termini e Condizioni di Rakumart",
  },
  {
    key: "用户中心",
    value: "Utenti",
  },
  {
    key: "免费注册",
    value: "Iscriviti gratis",
  },
  {
    key: "成为Rakumart的会员",
    value: "Diventa membro Rakumart",
  },
  {
    key: "搜索并支付产品的第一次付款",
    value: "Cerca i prodotti ed effettua il primo pagamento",
  },
  {
    key: "质量控制和储存在我们的中国仓库",
    value: "Controllo qualità e stoccaggio nel nostro magazzino in Cina",
  },
  {
    key: "第二次支付运费和国际航运",
    value: "Secondo saldo: spedizione e trasporto internazionale",
  },
  {
    key: "遵循运输过程并接收您的产品",
    value: "Traccia la tua spedizione",
  },
  {
    key: "要继续，请将产品添加到购物车",
    value: "Per continuare, aggiungi prodotti al carrello",
  },
  {
    key: "现在入住",
    value: "Inizia ora",
  },
  {
    key: "选择业务类型",
    value: "Seleziona Categoria business",
  },
  {
    key: "给你的建议",
    value: "Raccomandazioni per te",
  },
  {
    key: "如果您需要更改运输信息或运输方式，请与代理联系。",
    value:
      "Se devi modificare le informazioni o il Modalità di spedizione, contatta un consulente.",
  },
  {
    key: "服务或特殊要求",
    value: "Servizi o richieste speciali",
  },
  {
    key: "此字段为必填项",
    value: "Questo campo è obbligatorio",
  },
  {
    key: "产品支出总额",
    value: "Totale prodotti",
  },
  {
    key: "合计费用(China)",
    value: "Totale costi (Cina)",
  },
  {
    key: "佣金",
    value: "Commissione",
  },
  {
    key: "额外服务",
    value: "Servizi extra",
  },
  {
    key: "运费",
    value: "Costo di spedizione",
  },
  {
    key: "进口总成本的成本细目。",
    value: "Dettaglio dei costi totali di importazione.",
  },
  {
    key: "预计国际费用明细",
    value: "Dettaglio costi internazionali stimati",
  },
  {
    key: "预计交货时间",
    value: "Consegna stimata",
  },
  {
    key: "国际运输",
    value: "Trasporto internazionale",
  },
  {
    key: "意大利的运费",
    value: "Costo di spedizione in Italia",
  },
  {
    key: "意大利本地运费",
    value: "Costo di spedizione in Italia",
  },
  {
    key: "为什么现在估计装运?",
    value: "Perché la spedizione è stimata ora?",
  },
  {
    key: "订单金额必须大于",
    value: "Minimo d'ordine:",
  },
  {
    key: "选择装运的运输类型",
    value: "Seleziona il tipo di spedizione",
  },
  {
    key: "一个订单最多添加60个商品",
    value: "Puoi aggiungere al massimo 60 prodotti per ordine",
  },
  {
    key: "看到产品",
    value: "Visualizza prodotto",
  },
  {
    key: "总价格",
    value: "Prezzo totale",
  },
  {
    key: "商品数量",
    value: "Quantità",
  },
  {
    key: "更换产品",
    value: "Sostituisci prodotto",
  },
  {
    key: "已理解",
    value: "Ho capito",
  },
  {
    key: "加入 Rakumart",
    value: "Unisciti a Rakumart",
  },
  {
    key: "开始享受从中国进口Rakumart的好处吧。",
    value: "Inizia a scoprire i vantaggi di importare dalla Cina con Rakumart.",
  },
  {
    key: "发现所有的好处",
    value: "Scopri tutti i vantaggi",
  },
  {
    key: "注册或登入",
    value: "Accedi o Registrati",
  },
  {
    key: "邮件箱",
    value: "E-mail",
  },
  {
    key: "省份",
    value: "Pais",
  },
  {
    key: "订单摘要",
    value: "Riepilogo ordine",
  },
  {
    key: "购买金额",
    value: "Importo acquisto",
  },
  {
    key: "如何运作",
    value: "Come funziona",
  },
  {
    key: "我们联系制造商",
    value: "Contattiamo il produttore",
  },
  {
    key: "你会在24小时内收到信息",
    value: "Risposta garantita entro 24 ore",
  },
  {
    key: "我们通知您所有类型的估计费用 海运(空运、海运和陆运)。",
    value:
      "Ti informeremo sui costi stimati per le varie modalità di trasporto: aereo, marittimo e terrestre.",
  },
  {
    key: "你有什么问题吗?",
    value: "Hai domande?",
  },
  {
    key: "电子邮箱为",
    value: "L'email è",
  },
  {
    key: "使用聊天与我们沟通。",
    value: "Comunica con noi tramite chat.",
  },
  {
    key: "通过Whastapp给我们写信。",
    value: "Scrivici su WhatsApp.",
  },
  {
    key: "银行转帐",
    value: "Bonifico bancario",
  },
  {
    key: "把你的订单转到我们的银行账户。",
    value: "Trasferisci il pagamento dell'ordine sul nostro conto bancario.",
  },
  {
    key: "订单正在处理中",
    value: "Ordine in elaborazione",
  },
  {
    key: "请允许1至2个工作日处理订单。",
    value: "Il trattamento dell'ordine richiede 1-2 giorni lavorativi.",
  },
  {
    key: "我们进行购买",
    value: "Effettuiamo l'acquisto",
  },
  {
    key: "我们购买您的产品并将其送到我们的仓库。",
    value: "Acquistiamo i tuoi prodotti e li inviamo al nostro magazzino.",
  },
  {
    key: "产品付款",
    value: "Pagamento prodotti",
  },
  {
    key: "发货仓库",
    value: "Magazzino di spedizione",
  },
  {
    key: "进口商联系人",
    value: "Contatto importatore",
  },
  {
    key: "付款方式",
    value: "Metodo di pagamento",
  },
  {
    key: "信用卡",
    value: "Carta di credito",
  },
  {
    key: "接收银行信息",
    value: "Ricevi dati bancari",
  },
  {
    key:
      "使用以下银行信息通过您的网上银行或移动应用程序进行转账。一旦订单被处理，就会进行购买。",
    value:
      "Usa i dati bancari seguenti per effettuare il bonifico tramite home banking o app. L'acquisto sarà effettuato dopo l'elaborazione dell'ordine.",
  },
  {
    key: "使用订单号作为付款概念/参考:",
    value: "Inserire il numero d'ordine/riferimento nella causale:",
  },
  {
    key: "如果您想购买和发送此产品的样品，请联系专家代理。",
    value:
      "Se vuoi acquistare e spedire un campione di questo prodotto, contatta un consulente esperto.",
  },
  {
    key: "与代理联系",
    value: "Contatta un consulente",
  },
  {
    key:
      "这一细分包括产品的质量控制、合同规定的额外服务，以及在适当情况下合同规定的其他费用。",
    value:
      "Questa voce include il controllo qualità, i servizi extra richiesti e, se applicabile, altri costi previsti.",
  },
  {
    key:
      "为了提供最好的进口报价，一旦产品到达我们的仓库，就会计算出准确的运费和其他费用报价，所以现在你只支付产品。",
    value:
      "Per offrirti il miglior preventivo di importazione, i costi esatti di spedizione e altri costi saranno calcolati quando i prodotti arriveranno al nostro magazzino. Ora paghi solo i prodotti.",
  },
  {
    key: "由于货物的分组和其他数据，我们可以提供更好的装运的最终报价。",
    value:
      "Grazie al consolidamento della merce e agli altri dati disponibili, possiamo offrirti un preventivo finale di spedizione più accurato.",
  },
  {
    key: "收件人名称",
    value: "Nome destinatario",
  },
  {
    key: "SWIFT帐户",
    value: "Codice SWIFT",
  },
  {
    key: "银行名称",
    value: "Nome banca",
  },
  {
    key: "公司地址（国家/地区）",
    value: "Indirizzo azienda",
  },
  {
    key: "进行付款",
    value: "Paga ora",
  },
  {
    key: "银行国家",
    value: "Paese banca",
  },
  {
    key: "控制面板",
    value: "Pannello di controllo",
  },
  {
    key: "面板控制",
    value: "Gestione pannello",
  },
  {
    key: "修改数据",
    value: "Modifica dati",
  },
  {
    key: "我们从工厂接收你们的产品",
    value: "Riceviamo i tuoi prodotti dalla fabbrica",
  },
  {
    key: "质量控制和处理",
    value: "Controllo qualità e gestione",
  },
  {
    key: "购买您的产品的过程已经开始。",
    value: "Il processo di acquisto dei tuoi prodotti è iniziato.",
  },
  {
    key: "我们期待在我们的仓库收到你们的产品。",
    value: "Siamo in attesa di ricevere i tuoi prodotti nel nostro magazzino.",
  },
  {
    key: "我们收到产品并开始执行质量控制和额外服务(如有需要)。",
    value:
      "Riceviamo i prodotti e avviamo il controllo qualità e i servizi extra, se richiesti.",
  },
  {
    key: "运费和运输报价",
    value: "Preventivo spedizione e trasporto",
  },
  {
    key: "我们计算最好的运费报价，并在5-7天内装运你的货物。",
    value:
      "Calcoliamo il miglior preventivo di spedizione e spediamo la merce entro 5-7 giorni.",
  },
  {
    key: "运费的支付",
    value: "Pagamento spedizione",
  },
  {
    key: "付款后，您的货物将被送到我们在巴塞罗那的仓库和您的送货地址。",
    value:
      "Dopo il pagamento, la merce sarà inviata ai nostri magazzini a Barcellona e al tuo indirizzo di consegna.",
  },
  {
    key: "修改收货地址",
    value: "Modifica indirizzo di consegna",
  },
  {
    key: "城市",
    value: "Città",
  },
  {
    key: "支付地址",
    value: "Indirizzo di pagamento",
  },
  {
    key: "全名",
    value: "Nome completo",
  },
  {
    key: "国际航运付款",
    value: "Pagamento spedizione internazionale",
  },
  {
    key: "进口",
    value: "Importazione",
  },
  {
    key: "请联系客服修改配送单地址",
    value:
      "Contatta il servizio clienti per modificare l’indirizzo di spedizione",
  },
  {
    key: "替换商品",
    value: "Sostituisci prodotto",
  },
  {
    key: "库存不足商品",
    value: "Prodotti esauriti",
  },
  {
    key: "Rakumart消息",
    value: "Messaggi Rakumart",
  },
  {
    key: "可选择替换的商品",
    value: "Prodotti disponibili per la sostituzione",
  },
  {
    key: "Rakumart，我们帮助您从中国进口",
    value: "Rakumart ti aiuta a importare dalla Cina",
  },
  {
    key:
      "Rakumart让您轻松获得从中国进口的“一站式”服务，包括工厂采购、质量检验、附加服务和国际航运。",
    value:
      "Rakumart offre un servizio completo “one-stop” per importare dalla Cina: approvvigionamento, controllo qualità, servizi aggiuntivi e spedizione internazionale",
  },
  {
    key: "全面、便捷的中国进口管理。",
    value: "Gestione completa e semplificata dell’importazione dalla Cina",
  },
  {
    key: "专注于你的事业",
    value: "Concentrati sul tuo business",
  },
  {
    key: "我们为您进口并优化所有物流成本",
    value: "Gestiamo le importazioni e ottimizziamo tutti i costi logistici",
  },
  {
    key: "完整的工厂物流",
    value: "Logistica completa dalla fabbrica",
  },
  {
    key: "后勤服务",
    value: "Servizi logistici",
  },
  {
    key: "公平和有价值的佣金为您的业务",
    value: "Commissioni trasparenti e vantaggiose per il tuo business",
  },
  {
    key: "多消费，少佣金",
    value: "Più acquisti, meno commissioni",
  },
  {
    key: "为所有产品需求提供额外服务",
    value: "Servizi aggiuntivi per tutte le esigenze di prodotto",
  },
  {
    key: "服务和整体解决方案",
    value: "Soluzioni integrate e servizi",
  },
  {
    key: "创建新帐户",
    value: "Crea un nuovo account",
  },
  {
    key: "请至少选择一项物流方式",
    value: "Seleziona almeno un Modalità di spedizione",
  },
  {
    key: "商品标题",
    value: "Titolo prodotto",
  },
  {
    key: "商品规格",
    value: "Specifiche prodotto",
  },
  {
    key: "选择该商品",
    value: "Seleziona questo prodotto",
  },
  {
    key: "回到顶部",
    value: "Torna su",
  },
  {
    key: "你的最爱",
    value: "Preferiti",
  },
  {
    key: "资料库",
    value: "Archivio",
  },
  {
    key: "跟踪号码",
    value: "Numero di tracciamento",
  },
  {
    key: "注意:同一订单只能使用同一类型的优惠券。",
    value:
      "Nota: nello stesso ordine è possibile utilizzare un solo tipo di coupon",
  },
  {
    key: "我是公司的",
    value: "Azienda",
  },
  {
    key: "我是自主的",
    value: "Lavoratore autonomo",
  },
  {
    key: "个人消费者",
    value: "Cliente privato",
  },
  {
    key: "家庭和装饰部门",
    value: "Casa e arredamento",
  },
  {
    key: "体育部门",
    value: "Sport",
  },
  {
    key: "健身行业",
    value: "Fitness",
  },
  {
    key: "儿童部门",
    value: "Bambini",
  },
  {
    key: "办公室和文具部门",
    value: "Cancelleria e ufficio",
  },
  {
    key: "酒店业",
    value: "Ho.Re.Ca.",
  },
  {
    key: "宠物/动物部门",
    value: "Prodotti per animali",
  },
  {
    key: "化妆品行业",
    value: "Cosmetica",
  },
  {
    key: "技术部门",
    value: "Tecnologia",
  },
  {
    key: "美容/美发部门",
    value: "Bellezza e parrucchieri",
  },
  {
    key: "工具和专业部门",
    value: "Utensili e professionisti",
  },
  {
    key: "汽车行业",
    value: "Automotive",
  },
  {
    key: "时尚与配饰行业",
    value: "Moda e accessori",
  },
  {
    key: "安全部门",
    value: "Sicurezza",
  },
  {
    key: "多产品部门或集市",
    value: "Multi-categoria / Marketplace",
  },
  {
    key: "其他部门",
    value: "Altri settori",
  },
  {
    key: "批量回复",
    value: "Risposta massiva",
  },
  {
    key: "形象",
    value: "Immagine",
  },
  {
    key: "帮助",
    value: "Aiuto",
  },
  {
    key: "帮助中心",
    value: "Centro assistenza",
  },
  {
    key: "Rakumart常见问题",
    value: "FAQ: Domande frequenti",
  },
  {
    key: "用户指南",
    value: "Guida rapida",
  },
  {
    key: "售后服务",
    value: "Garanzia e Post-Vendita",
  },
  {
    key: "联系我们",
    value: "Assistenza clienti",
  },
  {
    key: "国际物流说明",
    value: "Logistica e spedizione Rakumart",
  },
  {
    key: "国际运费收费标准",
    value: "Logistica e spedizione Rakumart",
  },
  {
    key: "用户中心",
    value: "Utenti",
  },
  {
    key: "售后服务",
    value: "Garanzia e Post-Vendita",
  },
  {
    key: "联系我们",
    value: "Assistenza clienti",
  },
  {
    key: "关于订单数量的重要通知",
    value: "Avviso importante sulle quantità",
  },
  {
    key: "我们不进行零售销售。",
    value: "Solo vendita all'ingrosso",
  },
  {
    key: "Rakumart是一个批发进口平台，不提供零售销售服务。",
    value:
      "Rakumart è una piattaforma di importazione all’ingrosso e non offre servizi di vendita al dettaglio.",
  },
  {
    key: "最小运输量",
    value: "Minimo d'ordine (MOQ)",
  },
  {
    key: "对于需要达到最低运输量的运输方式，订单总额必须达到或超过最低限制：",
    value:
      "Per i metodi di spedizione con minimo richiesto, l’importo dell’ordine deve raggiungere il limite minimo:",
  },
  {
    key: "（陆运：21kg / 海运：1m³ / 铁路运输：21kg）",
    value: "(Terra: 21kg / Mare: 1m³ / Ferrovia: 21kg)",
  },
  {
    key: "进口成本",
    value: "Costi di importazione",
  },
  {
    key:
      "少量进口货物或未达到最低运输量的进口货物可能会增加总成本，导致该操作不具盈利性。",
    value:
      "Importazioni inferiori al minimo possono aumentare i costi e rendere l’operazione non redditizia.",
  },
  {
    key: "理解了",
    value: "Ho capito",
  },
  {
    key: "至少选择一个产品",
    value: "Seleziona almeno un prodotto",
  },
  {
    key: "报价正在处理中",
    value: "Preventivo in fase di elaborazione.",
  },
  {
    key: "非常好！报价处理中。",
    value: "Preventivo in fase di elaborazione.",
  },
  {
    key: "非常好！正在进行报价。",
    value: "Preventivo in elaborazione",
  },
  {
    key: "下一步操作",
    value: "Passo successivo",
  },
  {
    key: "我们联系制造商要求必要的信息和报价的订单。",
    value:
      "Contattiamo il produttore per ottenere le informazioni e il preventivo necessari.",
  },
  {
    key: "Rakumart是如何运作的?",
    value: "Come funziona Rakumart?",
  },
  {
    key: "等值附加费",
    value: "Regime di equivalenza",
  },
  {
    key: "如果你是在特别等同附加费制度下纳税的，请在购买发票上的方框内打勾。",
    value:
      "Se sei nel regime IVA di equivalenza, seleziona la casella nella fattura.",
  },
  {
    key: "费用明细",
    value: "Dettaglio costi",
  },
  {
    key: "产品成本细目",
    value: "Dettaglio costi prodotto",
  },
  {
    key: "所有产品总价:",
    value: "Totale prodotti:",
  },
  {
    key: "订单费用合计(中国)",
    value: "Totale ordine (Cina)",
  },
  {
    key: "所有产品的总价",
    value: "Totale di tutti i prodotti",
  },
  {
    key: "产品付款及运输",
    value: "Pagamento prodotti e spedizione",
  },
  {
    key: "选择此选项支付产品和运输。",
    value: "Seleziona questa opzione per pagare prodotti e spedizione.",
  },
  {
    key: "我们向工厂下订单，一旦质量控制通过，货物就开始国际运输。",
    value:
      "Effettuiamo l’ordine e, dopo il controllo qualità, avviamo la spedizione internazionale.",
  },
  {
    key: "仅支付产品",
    value: "Paga solo il prodotto",
  },
  {
    key: "如果您只想支付产品的成本，请选择此选项。",
    value: "Se vuoi pagare solo il prodotto, seleziona questa opzione.",
  },
  {
    key:
      "运费报价不包括在内，一旦货物进入我们的仓库，您可以通过自己的货运代理管理运输。",
    value:
      "Il costo di spedizione non è incluso; puoi gestirlo con il tuo spedizioniere.",
  },
  {
    key: "你也可以统一不同订单的货物，或者在另一个时间发货。",
    value: "Puoi anche consolidare ordini o spedire in un secondo momento.",
  },
  {
    key: "产品总价",
    value: "Totale prodotti",
  },
  {
    key: "运费总价",
    value: "Totale spedizione",
  },
  {
    key: "产品的支出总额",
    value: "Totale finale",
  },
  {
    key: "一旦订单报价，您可以通过银行转账或信用卡付款正式购买。",
    value:
      "Una volta ricevuto il preventivo, potrai completare l’acquisto tramite bonifico bancario o carta di credito.",
  },
  {
    key:
      "感谢您的垂询。我们已收到您的请求，正在处理中。您将在24小时内收到报价。您还将收到不同物流方式的报价。",
    value:
      "Grazie per la Sua richiesta.Abbiamo ricevuto correttamente la Sua richiesta.Entro 24 ore riceverà il preventivo e le istruzioni per il pagamento.Riceverà inoltre le quotazioni per le diverse soluzioni di trasporto disponibili.",
  },
  {
    key:
      "谢谢你。您的请求细节已成功确认。在不到24小时内，您将收到报价和订单付款细节的信息。您还将收到可能的运输方式的运输报价。",
    value:
      "Grazie. La tua richiesta è stata confermata con successo. Entro 24 ore riceverai il preventivo e i dettagli di pagamento dell’ordine, insieme alle opzioni di spedizione disponibili.",
  },
  {
    key: "可用的运输方式取决于您的订单详情（尺寸、产品净重等）。",
    value:
      "I metodi di spedizione disponibili variano in base alle caratteristiche dell'ordine (dimensioni, peso esatto dei prodotti, ecc.).",
  },
  {
    key: "下一步：",
    value: "I passaggi successivi:",
  },
  {
    key: "我们将联系供应商以获取必要信息及订单报价。",
    value:
      "Contattiamo il fornitore per richiedere informazioni e preventivo dell'ordine.",
  },
  {
    key: "我们将在24小时内为您报价",
    value: "Le invieremo un preventivo entro 24 ore",
  },
  {
    key: "我们将通知您各种运输方式（空运、海运、陆运）的预估费用。",
    value:
      "Ti comunicheremo i costi stimati per le varie modalità di spedizione (aereo, marittimo, terrestre).",
  },
  {
    key: "报价生成后，您可通过银行转账或信用卡支付完成订单。",
    value:
      "Una volta generato il preventivo, è possibile completare l'ordine tramite bonifico bancario o carta di credito.",
  },
  {
    key: "有疑问？",
    value: "Hai domande?",
  },
  {
    key: "邮箱:",
    value: "Email:",
  },
  {
    key: "使用rakuchat联系我们",
    value: "Contattaci tramite Rakuchat",
  },
  {
    key: "通过WhatsApp联系我们",
    value: "Contattaci su WhatsApp",
  },
  {
    key: "通过WhatsApp联系我们。",
    value: "Contattaci su WhatsApp",
  },
  {
    key: "推荐给您的商品",
    value: "Raccomandazioni per te",
  },
  {
    key:
      "符合条件的运输方式将取决于您的订单的特点(尺寸，产品的确切重量等)。如果订单没有超过任何运输方式的最小数量，它将出现在0。",
    value:
      "Le opzioni di spedizione disponibili dipendono dalle caratteristiche dell’ordine (dimensioni, peso effettivo, ecc.). Se non viene raggiunta la quantità minima per un Modalità di spedizione, il costo sarà pari a 0.",
  },
  {
    key: "谢谢，付款成功。很快你就会收到一封电子邮件，里面有确认和详细信息。",
    value:
      "Grazie, pagamento effettuato con successo. Riceverai a breve un’email con la conferma e tutti i dettagli.",
  },
  {
    key: "个人所得税",
    value: "Imposta sul reddito delle persone fisiche (IRPEF)",
  },
  {
    key: "付款详情",
    value: "Dettagli pagamento",
  },
  {
    key: "选择或添加送货地址",
    value: "Seleziona o aggiungi un indirizzo di consegna",
  },
  {
    key: "我的地址",
    value: "I miei indirizzi",
  },
  {
    key: "选择或添加新地址",
    value: "Seleziona o aggiungi un nuovo indirizzo",
  },
  {
    key: "亚马逊FBA取货",
    value: "Ritiro per Amazon FBA",
  },
  {
    key: "发货至亚马逊FBA仓库",
    value: "Spedizione al magazzino Amazon FBA",
  },
  {
    key: "请通过rakuchat或WhatsApp告知您要发货至的亚马逊仓库地址。",
    value:
      "Indicateci tramite rakuchat o WhatsApp l'indirizzo del magazzino Amazon a cui desideri spedire.",
  },
  {
    key: "添加收货地址",
    value: "Aggiungi indirizzo di consegna",
  },
  {
    key: "要求或增加额外服务",
    value: "Richiedi o aggiungi servizi aggiuntivi",
  },
  {
    key: "我们的专业顾问将与您联系，审核您的申请，并在必要时与您沟通细节。",
    value:
      "Un nostro consulente dedicato ti contatterà per esaminare la tua richiesta e, se necessario, approfondire i dettagli.",
  },
  {
    key: "专家代理将与您联系，审查您的申请，并在必要时澄清细节。",
    value:
      "Un agente specializzato ti contatterà per esaminare la richiesta e chiarire eventuali dettagli.",
  },
  {
    key: "需求类型",
    value: "Tipo di richiesta",
  },
  {
    key: "你必须选择一个关于等价附加费的选项",
    value: "Devi selezionare un’opzione relativa al regime di equivalenza IVA",
  },
  {
    key: "请选择具体的附加服务类型",
    value: "Seleziona il tipo specifico di servizio aggiuntivo",
  },
  {
    key: "按人口分列的城市",
    value: "Città per popolazione",
  },
  {
    key: "人口/城市",
    value: "Popolazione / Città",
  },
  {
    key: "输入您的人口/城市",
    value: "Inserisci la tua città",
  },
  {
    key: "输入您的公司或企业所在的国家",
    value: "Inserisci il paese della tua azienda",
  },
  {
    key: "Rakumart经验",
    value: "Esperienza Rakumart",
  },
  {
    key: "这个简短的调查将帮助我们个性化您与我们的体验。",
    value:
      "Questo breve sondaggio ci aiuterà a personalizzare la tua esperienza.",
  },
  {
    key: "商品的用途是什么?",
    value: "Destinazione d'uso?",
  },
  {
    key: "个人/私人使用",
    value: "Uso personale/privato",
  },
  {
    key: "分销和销售",
    value: "Distribuzione e vendita",
  },
  {
    key: "继续",
    value: "Continua",
  },
  {
    key: "什么样的销售你提供吗?",
    value: "Che tipo di vendita offri?",
  },
  {
    key: "批发商",
    value: "Grossista",
  },
  {
    key: "零售商",
    value: "Rivenditore",
  },
  {
    key: "你的主要销售渠道是什么?",
    value: "Qual è il tuo principale canale di vendita?",
  },
  {
    key: "您可以选择多个选项",
    value: "Puoi selezionare più opzioni",
  },
  {
    key: "电子商务",
    value: "E-commerce",
  },
  {
    key: "亚马逊",
    value: "Amazon",
  },
  {
    key: "实体店铺",
    value: "Negozio fisico / Retail",
  },
  {
    key: "其他平台",
    value: "Altre piattaforme",
  },
  {
    key: "你每年的进口量是多少?",
    value: "Qual è il tuo volume annuale di importazione?",
  },
  {
    key: "你从事进口业务多长时间了？",
    value: "Da quanto tempo operi nell'importazione?",
  },
  {
    key: "不到一年",
    value: "Meno di un anno",
  },
  {
    key: "超过一年",
    value: "Più di un anno",
  },
  {
    key: "回退",
    value: "Indietro",
  },
  {
    key: "验证帐户",
    value: "Verifica account",
  },
  {
    key: "请输入我们发送给您的验证码:",
    value: "Inserisci il codice che ti abbiamo inviato:",
  },
  {
    key: "您输入的验证码不正确。请检查代码或点击接收另一个。",
    value:
      "Il codice inserito non è corretto. Verificalo o richiedine un altro.",
  },
  {
    key: "校验",
    value: "Verifica",
  },
  {
    key: "检查我的验证码",
    value: "Controlla il mio codice",
  },
  {
    key: "您没有收到任何电子邮件吗？",
    value: "Non hai ricevuto alcuna email?",
  },
  {
    key: "点击此处",
    value: "Clicca qui",
  },
  {
    key: "以便我们再次为您发送",
    value: "per inviartelo di nuovo",
  },
  {
    key: "当订单金额为0时,无法付款",
    value: "Non è possibile pagare quando l’importo è 0",
  },
  {
    key: "超级工厂",
    value: "Super fabbrica",
  },
  {
    key: "实力商家",
    value: "Venditore Premium",
  },
  {
    key: "质量评分",
    value: "Valutazione qualità",
  },
  {
    key: "物流评分",
    value: "Valutazione logistica",
  },
  {
    key: "问题解决评分",
    value: "Valutazione risoluzione problemi",
  },
  {
    key: "咨询评分",
    value: "Valutazione consulenza",
  },
  {
    key: "筛选",
    value: "Filtro",
  },
  {
    key: "精选",
    value: "Premium",
  },
  {
    key: "1688严选商品",
    value: "Prodotti selezionati 1688",
  },
  {
    key: "1688严选工厂",
    value: "Fabbriche selezionate 1688",
  },
  {
    key: "店铺评分",
    value: "Valutazione negozio",
  },
  {
    key: "条件",
    value: "Condizioni",
  },
  {
    key: "七天无理由退换",
    value: "Reso entro 7 giorni",
  },
  {
    key: "一件起发",
    value: "Ordine minimo 1 pezzo",
  },
  {
    key: "图片加载失败",
    value: "Caricamento immagine non riuscito",
  },
  {
    key: "月销售总额",
    value: "Vendite mensili totali",
  },
  {
    key: "综合",
    value: "Classificazione generale",
  },
  {
    key: "每月销售",
    value: "Vendite mensili",
  },
  {
    key: "回购率",
    value: "Tasso di riacquisto",
  },
  {
    key: "按以下方式排序：",
    value: "Ordinare per:",
  },
  {
    key: "单价排序",
    value: "Ordina per prezzo unitario",
  },
  {
    key: "最低价格",
    value: "Prezzo minimo",
  },
  {
    key: "最高价格",
    value: "Prezzo massimo",
  },
  {
    key: "看到商店",
    value: "Visualizza negozio",
  },
  {
    key: "品质保证",
    value: "Qualità garantita",
  },
  {
    key: "清理",
    value: "Svuota",
  },
  {
    key: "产品名称",
    value: "Nome prodotto",
  },
  {
    key: "下载图片",
    value: "Scarica immagine",
  },
  {
    key: "下载所有的产品图片",
    value: "Scarica tutte le immagini dei prodotti",
  },
  {
    key: "你的一些产品无法上市",
    value: "Alcuni dei tuoi prodotti non possono essere pubblicati",
  },
  {
    key: "产品名",
    value: "Nome prodotto",
  },
  {
    key: "原因的影响",
    value: "Motivo dell’impatto",
  },
  {
    key: "取代",
    value: "Sostituisci",
  },
  {
    key: "非替代",
    value: "Non sostituire",
  },
  {
    key: "如果您不更换产品，产品成本将自动从您的订单总成本中扣除。",
    value:
      "Se non sostituisci il prodotto, il costo verrà automaticamente dedotto dal totale dell’ordine.",
  },
  {
    key: "如果您不确定，请与您的代理联系。",
    value: "Se non sei sicuro, contatta il tuo consulente.",
  },
  {
    key: "联系代理",
    value: "Contatta il consulente",
  },
  {
    key: "替换同样",
    value: "Sostituzione simile",
  },
  {
    key: "价格范围",
    value: "Fascia di prezzo",
  },
  {
    key: "与证书",
    value: "Con certificazione",
  },
  {
    key: "查看",
    value: "Visualizza",
  },
  {
    key: "您的产品已成功更换，感谢您信任Rakumart!",
    value:
      "Il tuo prodotto è stato sostituito con successo, grazie per la fiducia in Rakumart!",
  },
  {
    key: "你的产品没有被替换。请检查您的订单。",
    value: "Il tuo prodotto non è stato sostituito. Controlla il tuo ordine.",
  },
  {
    key: "不可替代",
    value: "Non sostituibile",
  },
  {
    key: "我们很抱歉。我们还没有发现类似的产品。请联系我们的代理解决问题。",
    value:
      "Ci dispiace, non abbiamo trovato prodotti simili. Contatta il nostro agente per assistenza.",
  },
  {
    key: "更换产品说明",
    value: "Istruzioni per la sostituzione del prodotto",
  },
  {
    key: "用功能和价格相似的产品替换你的侵权产品。",
    value: "Sostituisci il prodotto con uno simile per funzione e prezzo.",
  },
  {
    key:
      "如果您取消更换产品，它将从您的购物车中删除，并自动从您的商品总额中扣除。",
    value:
      "Se annulli la sostituzione, il prodotto verrà rimosso dal carrello e detratto automaticamente dal totale.",
  },
  {
    key: "取消替换您的产品将从购物车中删除，并自动从您的订单中删除。",
    value:
      "Annullando la sostituzione, il prodotto verrà rimosso dal carrello e dall’ordine.",
  },
  {
    key: "你的产品将被替换。",
    value: "Il tuo prodotto sarà sostituito.",
  },
  {
    key: "您的订单价格将自动更新。",
    value: "Il totale dell’ordine verrà aggiornato automaticamente.",
  },
  {
    key: "未替代产品",
    value: "Prodotti non sostituiti",
  },
  {
    key: "产品没有更换，您的订单总额已经扣除。",
    value: "Il prodotto non è stato sostituito e il totale è stato aggiornato.",
  },
  {
    key: "产品丢弃",
    value: "Prodotto eliminato",
  },
  {
    key: "消除产品",
    value: "Rimuovi prodotto",
  },
  {
    key: "将产品从购物车中移除。产品的金额将从订单的总成本中扣除。",
    value:
      "Rimuovi il prodotto dal carrello. Il valore verrà detratto dal totale ordine.",
  },
  {
    key: "通过图片搜索",
    value: "Cerca tramite foto",
  },
  {
    key: "介意聪明",
    value: "Ricerca intelligente",
  },
  {
    key: "从中国进口最简单、最安全的方式",
    value: "Il modo più semplice e sicuro per importare dalla Cina",
  },
  {
    key: "中国进口：一站式采购与物流解决方案",
    value: "Soluzioni di Importazione dalla Cina: Dall'ordine al tuo magazzino",
  },
  {
    key: "或者你可以搜索超过1亿种产品:",
    value: "Oppure puoi cercare tra oltre 100 milioni di prodotti:",
  },
  {
    key: "你准备好开始进口了吗？",
    value: "Sei pronto per iniziare a importare?",
  },
  {
    key: "按图片搜索产品(推荐)",
    value: "Cerca prodotti tramite immagine (consigliato)",
  },
  {
    key: "在这里发布图片",
    value: "Carica immagine qui",
  },
  {
    key:
      "我们正在寻找您的产品，并为您选择最好的供应商。温馨提示：请注意浏览器是否拦截了搜索结果界面的弹窗！！",
    value:
      "Stiamo cercando il tuo prodotto e selezionando i migliori fornitori. Promemoria: verifica se il browser ha bloccato la finestra dei risultati di ricerca!",
  },
  {
    key: "请稍等。",
    value: "Attendere prego",
  },
  {
    key: "*我们只从中国进口到意大利",
    value: "*Importiamo solo dalla Cina all’Italia",
  },
  {
    key: "事故",
    value: "Evento",
  },
  {
    key: "你在哪里认识我们的?",
    value: "Dove ci hai conosciuto?",
  },
  {
    key: "你能告诉我们在哪里?",
    value: "Puoi dirci dove?",
  },
  {
    key: "登录Rakumart",
    value: "Accedi a Rakumart",
  },
  {
    key: "输入您的登录凭证",
    value: "Inserisci le tue credenziali",
  },
  {
    key: "写你的电子邮件",
    value: "Inserisci la tua email",
  },
  {
    key: "输入您的密码",
    value: "Inserisci la password",
  },
  {
    key: "忘记密码？",
    value: "Hai dimenticato la password?",
  },
  {
    key: "保持登录状态",
    value: "Rimani connesso",
  },
  {
    key: "没有账户？",
    value: "Non hai ancora un account?",
  },
  {
    key: "创建您的Rakumart帐户",
    value: "Crea il tuo account Rakumart",
  },
  {
    key: "开启您的Rakumart之旅",
    value: "Inizia il tuo viaggio con Rakumart",
  },
  {
    key: "个人详细信息",
    value: "Dati personali",
  },
  {
    key: "输入您的个人信息",
    value: "Inserisci i dati personali",
  },
  {
    key: "公司的细节",
    value: "Dettagli dell'azienda",
  },
  {
    key: "输入您公司的详细信息",
    value: "Inserisci i dati della tua azienda",
  },
  {
    key: "填写一个简短的问卷，以个性化您的Rakumart体验",
    value:
      "Compila un breve questionario per personalizzare la tua esperienza Rakumart",
  },
  {
    key: "电子邮件，密码和电话",
    value: "Email, password e numero di telefono",
  },
  {
    key: "已下架",
    value: "Non disponibile",
  },
  {
    key: "您的公司/业务名称",
    value: "Nome azienda / attività",
  },
  {
    key: "您的公司或企业名称",
    value: "Ragione sociale",
  },
  {
    key: "网站",
    value: "Sito web",
  },
  {
    key: "如果你有",
    value: "Se hai",
  },
  {
    key: "您的主要业务部门",
    value: "Settore principale della tua attività",
  },
  {
    key: "选择您公司的行业",
    value: "Seleziona il settore della tua azienda",
  },
  {
    key: "C.F",
    value: "C.F.",
  },
  {
    key: "C.F. / Fiscal Code",
    value: "C.F. / Fiscal Code",
  },
  {
    key: "请输入C.F",
    value: "Inserisci il C.F.",
  },
  {
    key: "P.IVA/VAT NO",
    value: "P.IVA / VAT NO",
  },
  {
    key: "请输入P.IVA/VAT NO",
    value: "Inserisci P.IVA / VAT NO",
  },
  {
    key: "购买人身份",
    value: "Identità acquirente",
  },
  {
    key: "个人",
    value: "Privato",
  },
  {
    key: "公司",
    value: "Azienda",
  },
  {
    key: "公司进口商",
    value: "Importatore società",
  },
  {
    key: "个体户进口商",
    value: "Importatore individuale",
  },
  {
    key: "SDI",
    value: "SDI",
  },
  {
    key: "Codice Destinatario SDI",
    value: "Codice Destinatario SDI",
  },
  {
    key: "请输入SDI",
    value: "Inserisci SDI",
  },
  {
    key: "税号（CIF/NIF）",
    value: "Numero fiscale (CIF/NIF)",
  },
  {
    key: "请输入您的CIF/NIF",
    value: "Inserisci il tuo CIF/NIF",
  },
  {
    key: "登录详细信息",
    value: "Dati di accesso",
  },
  {
    key: "我们几乎完成了!填写您的详细信息以登录Rakumart。",
    value: "Ci siamo quasi! Completa i tuoi dati per accedere a Rakumart.",
  },
  {
    key: "输入安全密码",
    value: "Inserisci una password sicura",
  },
  {
    key: "重新输入密码",
    value: "Reinserisci la password",
  },
  {
    key: "请输入至少6位数的密码",
    value: "Inserisci una password di almeno 6 caratteri",
  },
  {
    key: "密码至少6位。",
    value: "La password deve contenere almeno 6 caratteri.",
  },
  {
    key: "*至少使用6个字符。它包括:",
    value: "*Utilizza almeno 6 caratteri, inclusi:",
  },
  {
    key: "大写和小写字母。",
    value: "Lettere maiuscole e minuscole.",
  },
  {
    key: "数字",
    value: "Numeri",
  },
  {
    key: "您必须接受隐私政策",
    value: "Devi accettare l’informativa sulla privacy",
  },
  {
    key: "我已阅读并接受",
    value: "Ho letto e accetto la",
  },
  {
    key: "隐私政策",
    value: "politica sulla privacy",
  },
  {
    key: "并授权接收有关Rakumart产品的通信",
    value: "e autorizzo l'invio di comunicazioni sui prodotti Rakumart.",
  },
  {
    key: "此问卷已完成填写并提交，无需再次填写",
    value:
      "Questo questionario è già stato compilato e inviato. Non è necessario compilarlo di nuovo.",
  },
  {
    key: "问卷填写完成！",
    value: "Questionario completato!",
  },
  {
    key: "我们将会为您提供更具个性化的服务！",
    value: "Ti offriremo un servizio ancora più personalizzato!",
  },
  {
    key: "欢迎来到Rakumart!",
    value: "Benvenuto su Rakumart!",
  },
  {
    key: "足不出户就开始从中国进口",
    value: "Importa dalla Cina, comodamente dal tuo ufficio",
  },
  {
    key: "开始",
    value: "Inizia",
  },
  {
    key: "输入密码吗?包含至少6个大写、小写、数字的字符。",
    value:
      "La password deve contenere almeno 6 caratteri, tra cui lettere maiuscole, minuscole, numeri.",
  },
  {
    key: "我们是你通往中国的桥梁",
    value: "Il tuo ponte per l'importazione dalla Cina",
  },
  {
    key: "触手可及的世界上最大的时尚市场",
    value: "Accedi facilmente al più grande mercato globale",
  },
  {
    key:
      "Rakumart 是企业对企业（B2B）一体化导入平台。我们为您管理从中国采购、物流和进口的整个过程。我们广泛的合作伙伴网络为您提供了广泛的产品选择和超过100,000家供应商，我们每天与他们合作。一项旨在帮助您推动业务发展的服务。",
    value:
      "Rakumart è una piattaforma B2B integrata per l’importazione. Gestiamo per te l’intero processo: approvvigionamento, logistica e importazione dalla Cina. Grazie alla nostra rete di partner, offriamo un’ampia selezione di prodotti e collaboriamo ogni giorno con oltre 100.000 fornitori per aiutarti a far crescere il tuo business.",
  },
  {
    key: "看视频",
    value: "Guarda il video",
  },
  {
    key: "便利从中国进口",
    value: "Importare dalla Cina in modo semplice",
  },
  {
    key: "找到你想要的一切",
    value: "Trova Tutti ciò che cerchi",
  },
  {
    key: "它受益于从中国进口的好处，而没有随之而来的复杂性。",
    value:
      "Approfitta dei vantaggi dell’importazione dalla Cina senza la complessità.",
  },
  {
    key: "具有经过验证的供应商的无限目录",
    value: "Catalogo illimitato di fornitori verificati",
  },
  {
    key: "进入世界上最大的批发市场，发现它提供的所有机会。",
    value:
      "Accedi al più grande mercato all’ingrosso del mondo e scopri tutte le opportunità che offre.",
  },
  {
    key: "与中国直接联系",
    value: "Connessione diretta con la Cina",
  },
  {
    key:
      "在这个过程的每个阶段控制你的货物。我们在中国和意大利的基础设施使进口的实时跟踪成为可能。",
    value:
      "Controlla la tua merce in ogni fase del processo. La nostra infrastruttura in Cina e in Italia consente il monitoraggio in tempo reale dell’importazione.",
  },
  {
    key: "个性化客户服务",
    value: "Servizio clienti personalizzato",
  },
  {
    key:
      "我们的专家团队将用意大利语回答您的所有问题，并指导您完成进口的每一步。",
    value:
      "Il nostro team di esperti risponderà in italiano a tutte le tue domande e ti guiderà in ogni fase dell’importazione.",
  },
  {
    key: "定制的商业体验",
    value: "Esperienza commerciale su misura",
  },
  {
    key:
      "定制您从中国进口的产品。选择您需要的产品，并根据您的具体需求定制服务。",
    value:
      "Personalizza la tua importazione dalla Cina. Scegli i prodotti di cui hai bisogno e adatta i servizi alle tue esigenze specifiche.",
  },
  {
    key: '我们<span style="color: #009246;">一起</span>创造独一无二的体验。',
    value:
      '<span style="color: #009246;">Insieme</span> creiamo un\'esperienza davvero unica.',
  },
  {
    key: "质量与可靠性",
    value: "Qualità e Affidabilità",
  },
  {
    key: "推荐的时尚供应商",
    value: "Fornitori moda consigliati",
  },
  {
    key: "通过你的屏幕，就像你在中国一样重要！",
    value: "La Cina a portata di schermo, come se fossi lì!",
  },
  {
    key: "优化导入流程",
    value: "Ottimizza il processo di importazione",
  },
  {
    key:
      "使用Rakumart导入，并在5个简单的步骤中简化导入过程。我们负责进口，你负责你的生意。",
    value:
      "Importa con Rakumart e semplifica il processo in 5 semplici passaggi. Noi gestiamo l’importazione, tu il tuo business.",
  },
  {
    key:
      "在Rakumart中，您可以通过图像搜索产品，优化您的搜索，以找到您想要进口的产品。",
    value:
      "Su Rakumart puoi cercare prodotti tramite immagini e trovare rapidamente ciò che desideri importare.",
  },
  {
    key: "创建新订单",
    value: "Crea un nuovo ordine",
  },
  {
    key: "找到产品，进行定制并添加服务。您将收到一份包含中国发货运费的报价。",
    value:
      "Trova il prodotto, personalizzalo e aggiungi i servizi. Riceverai un preventivo che include le spese di spedizione dalla Cina.",
  },
  {
    key: "定制你的产品",
    value: "Personalizza il tuo prodotto",
  },
  {
    key: "你有 Logo 吗？定制包装和图片，让你的产品真正独一无二。",
    value:
      "Hai un logo? Personalizza il packaging e le immagini per rendere i tuoi prodotti davvero unici.",
  },
  {
    key: "货物的报价和付款",
    value: "Preventivo e pagamento",
  },
  {
    key: "报价和付款",
    value: "Preventivo e pagamento",
  },
  {
    key:
      "我们将在48小时内报价您的订单和运输费用。Rakumart确保安全可靠的支付，保护您的数据在每一笔交易。",
    value:
      "Entro 48 ore riceverai un preventivo per il tuo ordine e le spese di spedizione.",
  },
  {
    key: "物流、发货和交付",
    value: "Logistica, spedizione e consegna",
  },
  {
    key: "付款后，我们将按照所选方式发货。",
    value: "Dopo il pagamento spediamo secondo il metodo scelto.",
  },
  {
    key: "好进口商俱乐部",
    value: "Club importatori",
  },
  {
    key: "超过10,000个注册用户",
    value: "Oltre 10.000 utenti registrati",
  },
  {
    key: "我们的社区每天都在增长。加入它，享受与Rakumart进口的好处。",
    value:
      "La nostra community cresce ogni giorno. Unisciti a noi e scopri i vantaggi di importare con Rakumart.",
  },
  {
    key:
      "“Rakumart为你提供了很多便利，你可以把所有东西都放在家门口，而不必担心任何你不知道如何管理的事情。”",
    value:
      "“Rakumart semplifica Tutti: puoi ricevere la merce direttamente a destinazione senza preoccuparti di procedure che non sai come gestire.”",
  },
  {
    key: "亚马逊卖家",
    value: "Venditore Amazon",
  },
  {
    key:
      "“你省去了很多麻烦，可以把时间花在你真正感兴趣的业务上，而不是花在官僚程序上。”",
    value:
      "“Dimentica molte complicazioni e ti permette di dedicare tempo al tuo business, invece che alla burocrazia.”",
  },
  {
    key: "“我对你们的客户服务和待遇非常满意。可取的。”",
    value:
      "“Sono molto soddisfatto del servizio clienti e dell’assistenza ricevuta. Consigliato.”",
  },
  {
    key:
      "“Rakumart将整个导入过程打包在一个包中，整个过程都是意大利语的，这使得沟通更加流畅和容易。”",
    value:
      "“Rakumart riunisce l’intero processo di importazione in un unico servizio, Tutti in italiano, rendendo la comunicazione molto più semplice e fluida.”",
  },
  {
    key: "“它大大简化了从中国进口到这里的过程，也简化了商品的标签和包装。”",
    value:
      "“Ha semplificato molto l’importazione dalla Cina, inclusi etichettatura e imballaggio dei prodotti.”",
  },
  {
    key:
      "“他们从头到尾都在指导你。这让事情变得更容易。它让你更容易专注于你的业务。”",
    value:
      "“Ti guidano dall’inizio alla fine. Tutti diventa più semplice e puoi concentrarti meglio sul tuo business.”",
  },
  {
    key: "用Rakumart推动你的业务",
    value: "Fai crescere il tuo business con Rakumart",
  },
  {
    key: "现在注册，加入我们的社区。",
    value: "Registrati ora ed entra a far parte della nostra community.",
  },
  {
    key: "查看Rakumart进口常见问题，了解你可享受的所有优势和保障。",
    value:
      "Consulta le domande frequenti sull'importazione con Rakumart e scopri vantaggi e garanzie a tua disposizione.",
  },
  {
    key: "什么是Rakumart？",
    value: "Cos’è Rakumart?",
  },
  {
    key:
      "Rakumart是一个“一体化”的进口平台，将意大利用户与数千家中国供应商连接起来，以具有竞争力的价格提供产品。我们管理整个过程：采购，订单，质量检查，运输和售后服务，客户服务100%用意大利语。",
    value:
      "Rakumart è una piattaforma di importazione all-in-one che collega gli utenti italiani a migliaia di fornitori cinesi, offrendo prodotti a prezzi competitivi. Gestiamo l’intero processo: ricerca prodotto, ordine, controllo qualità, spedizione e assistenza post-vendita, con servizio clienti 100% in italiano.",
  },
  {
    key: "我们为哪些国家客户提供从中国进口商品的服务？",
    value: "Da dove importiamo?",
  },
  {
    key:
      "在rakumart.it，我们只为意大利客户提供从中国进口商品的服务。我们还有rakumart.es、rakumart.us、rakumart.com等网站，您可以根据自己的需要进行选择。",
    value:
      "Su rakumart.it offriamo servizi di importazione dalla Cina esclusivamente per clienti italiani.<br>Disponiamo anche di siti come rakumart.es, rakumart.us e rakumart.com, che potete scegliere in base alle vostre esigenze.",
  },
  {
    key: "需要账户才能下单吗？",
    value: "Serve un account per effettuare un ordine?",
  },
  {
    key:
      "是的，你需要一个帐户。在rakumart.it免费注册，开始订购。有了您的帐户，您将能够访问有用的工具来管理和监控您的购买。此外，您的个人信息将被安全存储，使未来的订单更容易和快速。",
    value:
      "Sì, è necessario un account. Registrati gratuitamente su rakumart.it per iniziare a ordinare. Con il tuo account potrai accedere a strumenti utili per gestire e monitorare gli acquisti. Inoltre, i tuoi dati saranno archiviati in modo sicuro per rendere gli ordini futuri più semplici e veloci.",
  },
  {
    key: "我们的服务面向谁？",
    value: "A chi è rivolto il nostro servizio?",
  },
  {
    key:
      "Rakumart 面向希望以具有竞争力的价格批量采购产品的企业、公司和自由职业者。我们提供个性化OEM服务，以满足具体需求，并支持客户发展壮大。",
    value:
      "Rakumart è pensato per aziende, imprese e liberi professionisti che desiderano acquistare prodotti all'ingrosso a prezzi competitivi. Offriamo servizi OEM personalizzati per soddisfare esigenze specifiche e supportare la crescita dei clienti attraverso la produzione su misura e il supporto allo sviluppo del brand.",
  },
  {
    key: "Rakumart有什么优势？",
    value: "Quali sono i vantaggi di Rakumart?",
  },
  {
    key:
      "Rakumart以具有竞争力的价格提供产品，支持从多个经过验证的供应商处集中采购并合并为一次发货，有助于优化进口成本。服务包括意大利境内物流、质检、报关管理和客服支持，并提供意大利语支持。",
    value:
      "Rakumart offre prodotti a prezzi competitivi, supporta l'acquisto centralizzato da più fornitori verificati con consolidamento in un'unica spedizione, contribuendo a ottimizzare i costi di importazione. Il servizio include logistica in Italia, controllo qualità, gestione delle pratiche doganali e assistenza clienti, con supporto in italiano.",
  },
  {
    key: "我们如何审核供应商？",
    value: "Come verifichiamo i fornitori?",
  },
  {
    key:
      "在Rakumart，我们通过严格的选择过程来保证我们供应商的质量和可靠性。我们评估产品、交货时间和沟通。凭借在中国、日本、韩国和巴西的经验，我们了解全球需求，并保持可靠供应商的最新数据库。此外，我们保持持续沟通，以确保质量标准得到满足.",
    value:
      "In Rakumart garantiamo qualità e affidabilità dei fornitori attraverso un processo di selezione rigoroso. Valutiamo prodotti, tempi di consegna e comunicazione. Grazie alla nostra esperienza internazionale, manteniamo un database aggiornato di fornitori affidabili. Inoltre, manteniamo una comunicazione continua per garantire il rispetto degli standard di qualità.",
  },
  {
    key: "在Rakumart注册",
    value: "Registrati su Rakumart",
  },
  {
    key: "输入您的电子邮件开始在 Rakumart 意大利站注册。",
    value:
      "Inserisci la tua email per iniziare la registrazione su Rakumart Italia.",
  },
  {
    key: "你有一个帐户吗？",
    value: "Hai già un account?",
  },
  {
    key: "多谢了！",
    value: "Grazie!",
  },
  {
    key: "表单已成功发送。现在我们可以根据您的需要定制您的导入体验。",
    value:
      "Il modulo è stato inviato correttamente. Ora possiamo personalizzare la tua esperienza di importazione in base alle tue esigenze.",
  },
  {
    key: "去Rakumart",
    value: "Vai a Rakumart",
  },
  {
    key: "退后一步",
    value: "Torna indietro",
  },
  {
    key: "数千家已验证的供应商",
    value: "Migliaia di fornitori verificati",
  },
  {
    key: "我们的专家团队将为您对接市场上最优质的供应商。",
    value:
      "Il nostro team di esperti ti mette in contatto con i migliori fornitori del mercato.",
  },
  {
    key: "从中国，直接送到你的办公室",
    value: "Dalla Cina, direttamente nel tuo ufficio",
  },
  {
    key: "让与中国的贸易更便捷",
    value: "Rendere il commercio con la Cina più semplice e conveniente",
  },
  {
    key: "从中国进口的所有优势，简单无忧。",
    value:
      "Tutti i vantaggi dell'import dalla Cina, con semplicità e senza preoccupazioni.",
  },
  {
    key:
      "在 Rakumart，你可以找到数百万种来自中国优质供应商的产品，质量可靠，价格有竞争力.",
    value:
      "Su Rakumart puoi trovare milioni di prodotti da fornitori cinesi di qualità, con affidabilità e prezzi competitivi.",
  },
  {
    key:
      "没有更多烦恼！我们负责从工厂到您家门口的整个物流流程。您只需专注于您的业务。",
    value:
      "Niente più preoccupazioni! Gestiamo l'intero flusso logistico dalla fabbrica fino alla tua porta. Devi solo concentrarti sul tuo business.",
  },
  {
    key: "单一平台上的全部流程",
    value: "Tutti il processo su un’unica piattaforma",
  },
  {
    key: "+100,000家已验证供应商。",
    value: "<b>+100.000 fornitori</b> verificati.",
  },
  {
    key: "数百万种商品可供选择.",
    value: "<b>Milioni di prodotti</b> tra cui scegliere.",
  },
  {
    key: "1688.com的官方合作伙伴",
    value:
      '<b>Partner</b> ufficiale di <b style="color: #DC6803;">1688.com</b>',
  },
  {
    key: "请输入关键词或1688/alibaba商品链接",
    value:
      "Inserisci una parola chiave oppure un link prodotto di 1688/Alibaba.",
  },
  {
    key: "我们负责所有单证、手续与海关流程的管理。",
    value:
      "<b>Ci occupiamo di tutta la gestione</b> documentale, pratiche e procedure doganali.",
  },
  {
    key:
      "我们在中国和意大利都有物流基础设施，让我们能在整个进口流程中掌控您的货物。",
    value:
      "Disponiamo di <b>infrastruttura logistica</b> sia <b>in Cina che in Italia</b>, ciò ci consente di tenere sotto controllo la tua merce durante tutto il processo di importazione.",
  },
  {
    key:
      "我们在中国和意大利都有机构，让我们能在整个进口流程中掌控货物派送进展。",
    value:
      "Disponiamo di infrastruttura logistica sia in Cina che in Italia, ciò ci consente di tenere sotto controllo la tua merce durante tutto il processo di importazione.",
  },
  {
    key: "全流程100%意大利语服务。",
    value: "Tutto il processo <b>100% in italiano</b>.",
  },
  {
    key: "实时跟踪您的货物。",
    value: "Controllo in <b>tempo reale</b> della tua merce.",
  },
  {
    key: "创建供应商和商品收藏夹，随时取用。",
    value:
      "Crea <b>collezioni di fornitori e prodotti</b> per averli sempre a portata di mano.",
  },
  {
    key: "成为最大进口商社区的一员。",
    value: "Entra a far parte della più grande <b>comunità di importatori</b>.",
  },
  {
    key:
      "从一个地方管理你的商品。所有在一起！无需离开我们的平台即可享受导入过程。",
    value:
      "Gestisci Tutti da un unico posto. Tutti insieme, senza uscire dalla piattaforma.",
  },
  {
    key: "优化产品搜索",
    value: "Ottimizza la ricerca dei prodotti",
  },
  {
    key: "简化流程，找到你想要的东西",
    value: "Semplifica il processo e trova ciò che cerchi",
  },
  {
    key: "通过图片或链接在1688上搜索，节省业务时间。你是我们的优先事项。",
    value:
      "Cerca su 1688 tramite immagini o link e risparmia tempo per la tua attività. Sei la nostra priorità.",
  },
  {
    key: "无限目录",
    value: "Catalogo illimitato",
  },
  {
    key: "数以百万计的认证产品",
    value: "Milioni di prodotti verificati",
  },
  {
    key:
      "发现你的下一个商业机会！通过我们与1688.com的合作，访问全球最大的制造商目录。",
    value:
      "Scopri la tua prossima opportunità di business! Accedi al più grande catalogo mondiale di produttori grazie alla nostra collaborazione con 1688.com.",
  },
  {
    key:
      "我们的社区每天都在增长。加入更大的进口商社区，享受与Rakumart进口的好处。",
    value:
      "La nostra community cresce ogni giorno. Unisciti alla rete di importatori e scopri i vantaggi Rakumart.",
  },
  {
    key: "购物车添加失败",
    value: "Errore: prodotto non aggiunto",
  },
  {
    key: "增加",
    value: "Aggiungi",
  },
  {
    key: "Rakumart的后勤和运输",
    value: "Logistica e spedizione Rakumart",
  },
  {
    key: "物流价格",
    value: "Costo logistico",
  },
  {
    key: "使用WhatsApp扫码，开启对话",
    value: "Scansiona il QR code con WhatsApp per avviare una conversazione",
  },
  {
    key: "发起聊天",
    value: "Avvia chat",
  },
  {
    key: "下载订购交货",
    value: "Scarica ordine e spedizione",
  },
  {
    key: "国际运输费用",
    value: "Costi spedizione internazionale",
  },
  {
    key: "汇率",
    value: "Tasso di cambio",
  },
  {
    key: "总费用",
    value: "Costo totale",
  },
  {
    key: "进口商信息",
    value: "Informazioni importatore",
  },
  {
    key: "信息接收者",
    value: "Destinatario informazioni",
  },
  {
    key: "每包数量",
    value: "Quantità per pacco",
  },
  {
    key: "包装清单详细信息",
    value: "Packing List",
  },
  {
    key: "长度",
    value: "Lunghezza",
  },
  {
    key: "宽度",
    value: "Larghezza",
  },
  {
    key: "高度",
    value: "Altezza",
  },
  {
    key: "单一产品成本估算",
    value: "Costo unitario stimato",
  },
  {
    key: "商品进口成本预估",
    value: "Stima dei costi di importazione",
  },
  {
    key: "国家后勤",
    value: "Logistica nazionale",
  },
  {
    key: "确认付款",
    value: "Conferma il pagamento",
  },
  {
    key: "确定签收",
    value: "Conferma ricezione",
  },
  {
    key: "商品备注",
    value: "Note",
  },
  {
    key: "Rakumart备注",
    value: "Note Rakumart",
  },
  {
    key: "支出小计",
    value: "Subtotale spese",
  },
  {
    key: "境内运费(China)",
    value: "Costi di trasporto interno (Cina)",
  },
  {
    key: "境内运费 (Italia)",
    value: "Costi di trasporto interno (Italia)",
  },
  {
    key: "包括关税",
    value: "Inclusi dazi doganali",
  },
  {
    key: "国内航运在意大利",
    value: "Spedizione nazionale (Italia)",
  },
  {
    key: "被动主体的反转",
    value: "Reverse charge",
  },
  {
    key: "费用类别",
    value: "Categoria costi",
  },
  {
    key: "接受通过以下信用卡支付",
    value: "Accettiamo i seguenti metodi di pagamento con carta",
  },
  {
    key: "通过WorldFirst信用卡支付",
    value: "Pagamento con carta WorldFirst",
  },
  {
    key: "在这里，您必须填写发件人的姓名或公司名称。",
    value: "Qui devi inserire il nome del mittente o della società.",
  },
  {
    key: "复制成功",
    value: "Copiato",
  },
  {
    key: "填写任何有关付款和账单的信息或问题。",
    value:
      "Inserisci eventuali informazioni o domande su pagamento e fatturazione.",
  },
  {
    key: "请点击上边上传您完成付款的截图。",
    value: "Clicca sopra per caricare la prova di pagamento.",
  },
  {
    key: "更新于",
    value: "Aggiornato il",
  },
  {
    key: "你可以通过 YouTube 频道了解更多信息。",
    value: "Puoi scoprire di più sul nostro canale YouTube.",
  },
  {
    key: "中国营业时间",
    value: "Orari operativi Cina",
  },
  {
    key: "除星期六、星期日和中国法定节假日外",
    value: "Esclusi weekend e festività cinesi",
  },
  {
    key: "西班牙时间 03:00-12:00",
    value: "Orario Spagna 03:00–12:00",
  },
  {
    key: "意大利时间 03:00-12:00",
    value: "Ora italiana 03:00-12:00",
  },
  {
    key: "中国时间 09:00-18:00",
    value: "Orario Cina 09:00–18:00",
  },
  {
    key: "所有产品",
    value: "Tutti i prodotti",
  },
  {
    key: "中国时间",
    value: "Orario Pechino (Cina)",
  },
  {
    key: "国际运输详情",
    value: "Dettagli spedizione internazionale",
  },
  {
    key: "附加服务费用",
    value: "Costi servizi aggiuntivi",
  },
  {
    key: "计算费用",
    value: "Calcola costi",
  },
  {
    key: "欧盟内部运输",
    value: "Trasporto intra-UE",
  },
  {
    key: "安装Google购物插件后可通过图片在站内直接搜索",
    value:
      "Dopo aver installato l’estensione Google, puoi cercare direttamente su rakumart i prodotti desiderati tramite immagini. 🎉",
  },
  {
    key: "安装Chrome扩展",
    value: "Installa l’estensione Chrome",
  },
  {
    key: "天",
    value: "giorni",
  },
  {
    key: "是",
    value: "Sì",
  },
  {
    key: "否",
    value: "No",
  },
  {
    key: "在Rakumart西班牙仓库取货",
    value: "Ritiro presso Rakumart Spagna",
  },
  {
    key: "Beeping仓库地址",
    value: "Carrer dels Artesans, 29, 46970 Alaquàs, Valencia, Spagna",
  },
  {
    key: "箱号",
    value: "Numero collo",
  },
  {
    key: "产品意大利语名称",
    value: "Nome prodotto in italiano",
  },
  {
    key: "月销量",
    value: "Vendite mensili",
  },
  {
    key: "复购率",
    value: "Tasso di riacquisto",
  },
  {
    key: "由Rakumart管理的运输",
    value: "Spedizione gestita da Rakumart",
  },
  {
    key: "信用卡支付提示标题",
    value: "Attenzione",
  },
  {
    key: "信用卡支付手续费说明",
    value:
      "Pagando con carta di credito si applica una commissione del 2,9%, a carico dell’acquirente.",
  },
  {
    key: "如何将信用卡添加到WorldFirst账户",
    value: "Come aggiungere la carta di credito al conto WorldFirst",
  },
  {
    key: "了解更多链接",
    value: "Scopri di più >>",
  },
  {
    key: "WorldFirst是阿里巴巴跨境支付平台",
    value:
      "WorldFirst è la piattaforma di pagamenti transfrontalieri di Alibaba.",
  },
  {
    key: "您尚未开通信用卡支付如需激活",
    value:
      "Non ha ancora attivato il canale di pagamento con carta di credito. ",
  },
  {
    key: "请联系Rakumart激活信用卡",
    value: "Contatti Rakumart",
  },
  {
    key: "激活信用卡渠道结尾",
    value: " per attivarlo.",
  },
  {
    key: "反倾销税为零时的海关说明",
    value:
      "*Rakumart si occupa dello sdoganamento; il costo è incluso nella spedizione.",
  },
  {
    key: "增值税反向征收说明",
    value:
      "*Operazione assoggettata a inversione contabile ai sensi dell’art. 17 del D.P.R. 633/1972 (IVA).",
  },
  {
    key: "规格已过期无法购买请更换规格",
    value:
      "non è più disponibile e non può essere acquistata. Seleziona un’altra variante del prodotto.",
  },
  {
    key: "等待报价的交货订单",
    value: "Ordine di consegna in preventivo",
  },
  {
    key: "等待付款的交货订单",
    value: "Ordine di consegna in attesa di pagamento",
  },
  {
    key: "等待发货的交货订单",
    value: "Ordine di consegna in attesa di spedizione",
  },
  {
    key: "已发货的交货订单",
    value: "Ordine di consegna spedito",
  },
  {
    key: "意大利国内配送中的交货订单",
    value: "Consegna in corso in Italia",
  },
  {
    key: "已签收的交货订单",
    value: "Ordine di consegna ricevuto",
  },
  {
    key: "临时保存订单页面标题",
    value: "Ordine salvato temporaneamente",
  },
  {
    key: "等待报价的订单页面标题",
    value: "Ordini in attesa di preventivo",
  },
  {
    key: "等待付款的订单页面标题",
    value: "Ordini in attesa di pagamento",
  },
  {
    key: "等待采购的订单页面标题",
    value: "Ordini di acquisto in attesa",
  },
  {
    key: "质检已完成页面标题",
    value: "Controllo qualità completato",
  },
  {
    key: "订单已取消页面标题",
    value: "Ordine annullato",
  },
  {
    key: "订单详情页面标题",
    value: "Dettagli ordine",
  },
  {
    key: "侵权仿冒商品",
    value: "Prodotto non conforme (imitazione o contraffazione)",
  },
  {
    key: "无库存原因说明",
    value: "Esaurito (prodotto non disponibile)",
  },
  {
    key: "缺少CE认证说明",
    value: "Senza certificazione (manca il marchio CE)",
  },
  {
    key: "问题件数量标签",
    value: "Segnalazioni",
  },
  {
    key: "可替换数量标签",
    value: "Sostituzioni",
  },
  {
    key: "使用google账号注册/登录",
    value: "Registrati/Accedi con account Google",
  },
  {
    key: "Google 注册/登录",
    value: "Registrati/Accedi con Google",
  },
  {
    key: "请保存好以下信息",
    value: "Salva le seguenti informazioni",
  },
  {
    key: "默认密码",
    value: "Password predefinita",
  },
  {
    key: "建议您立即修改默认密码,并且补充个人资料",
    value:
      "Ti consigliamo di modificare immediatamente i dati personali e la password predefinita!",
  },
  {
    key: "去补充",
    value: "Completa i dati",
  },
  {
    key: "立即修改",
    value: "Modifica ora",
  },
  {
    key: "国际阿里巴巴",
    value: "Alibaba Internazionale",
  },
  {
    key: "查看1688链接",
    value: "Visualizza link 1688",
  },
  {
    key: "查看阿里巴巴链接",
    value: "Visualizza link Alibaba",
  },
  {
    key: "国际阿里巴巴支付手续费（3%）",
    value: "Commissione di pagamento Alibaba Internazionale (3%)",
  },
  {
    key:
      "手续费固定为商品金额的3%，该手续费由Alibaba进行收取，RAKUMART代收后支付至Alibaba。",
    value:
      "La commissione è fissa al 3% dell'importo del prodotto. Questa commissione è riscossa da Alibaba e RAKUMART la incassa per conto di Alibaba.",
  },
  // 我们是谁页面
  {
    key: "我们是谁：您值得信赖的中国进口合作伙伴",
    value: "Quiénes somos: Tu socio confiable para importar de China",
  },
  {
    key: "Rakumart 是一个一站式进口平台，替您管理整个采购、物流和进口过程。",
    value:
      "Rakumart è la piattaforma di importazione all-in-one in cui gestiamo per te l'intero processo di acquisto, logistica e importazione.",
  },
  {
    key: "立即注册",
    value: "Crea un nuovo account",
  },
  {
    key: "从中国进行B2B电子商务的最强解决方案。",
    value: "La soluzione più potente per l'e-commerce B2B dalla Cina.",
  },
  {
    key:
      "Rakumart是一家B2B企业，其主要目标是帮助意大利企业以最经济高效的方式从中国进口产品，减少成本和流程，并为客户提供最佳的进口体验。",
    value:
      "Rakumart è un'azienda B2B il cui obiettivo principale è aiutare le imprese italiane a importare prodotti dalla Cina nel modo più economico ed efficiente possibile, riducendo costi e procedure e offrendo ai clienti la migliore esperienza di importazione.",
  },
  {
    key:
      "总部位于中国义乌，我们拥有独立的技术研发团队，办公运营空间超过2,500平方米，集团公司所属的仓库面积达到70,000平方米，员工总数超过300人。",
    value:
      "Con sede a Yiwu, in Cina, disponiamo di un team indipendente di ricerca e sviluppo tecnologico, di spazi operativi per uffici superiori a 2.500 metri quadrati, di magazzini appartenenti alle società del gruppo per una superficie totale di 70.000 metri quadrati e di oltre 300 dipendenti.",
  },
  {
    key: "办公室",
    value: "di uffici",
  },
  {
    key: "仓库",
    value: "Magazzino",
  },
  {
    key: "员工",
    value: "dipendenti",
  },
  {
    key: "简化您从中国的购物与进口",
    value: "Semplifica i tuoi acquisti e le tue importazioni dalla Cina",
  },
  {
    key:
      "我们的平台使意大利用户能够轻松访问一体化的进口服务，包括采购、下单、质量检查、国际运输以及意大利语语的售后服务。",
    value:
      "La nostra piattaforma consente agli utenti italiani di accedere facilmente a un servizio di importazione integrato, che include acquisto, ordine, controllo qualità, trasporto internazionale e assistenza post-vendita in lingua italiana.",
  },
  {
    key: "降低产品成本，提高业务盈利能力",
    value:
      "Riduci il costo dei prodotti, aumenta la redditività del tuo business",
  },
  {
    key: "我们负责所有文件管理、手续及海关流程",
    value:
      "Ci occupiamo di tutta la gestione dei documenti, delle pratiche e delle procedure doganali",
  },
  {
    key: "在中国和意大利建立基础设施，为您的业务带来更多收益",
    value:
      "Creiamo infrastrutture in Cina e in Italia per portare maggiori profitti alla tua attività",
  },
  {
    key: "提供陪伴、咨询、意大利语客户服务及售后服务",
    value:
      "Offriamo accompagnamento, consulenza, assistenza clienti in italiano e servizio post-vendita",
  },
  {
    key: "寻找你想要的一切——世界工厂尽在掌握之中。",
    value: "Trova tutto ciò che cerchi, la fabbrica del mondo nelle tue mani.",
  },
  {
    key:
      "目前，Rakumart 的用户可以找到在中国主要电子商务平台上提供的任何产品。",
    value:
      "Attualmente, gli utenti di Rakumart possono trovare qualsiasi prodotto disponibile sulle principali piattaforme cinesi di commercio elettronico.",
  },
  {
    key:
      "我们广泛的合作网络使我们能够为您提供丰富的产品选择，以及每天在我们全球各地不同办事处合作的超过 100,000 家高质量的中国供应商。",
    value:
      "La nostra ampia rete di collaboratori ci permette di offrirti una vasta gamma di prodotti e più di 100.000 fornitori cinesi di alta qualità con cui lavoriamo quotidianamente nelle nostre diverse sedi in tutto il mondo.",
  },
  {
    key: "数百万",
    value: "Milioni",
  },
  {
    key: "种产品可供选择",
    value: "di prodotti disponibili",
  },
  {
    key: "家经过验证的供应商",
    value: "fornitori verificati",
  },
  {
    key: "我们帮助您的业务变得更加盈利",
    value: "Aiutiamo la tua attività a essere più redditizia",
  },
  {
    key:
      "Rakumart 允许您在世界上最大的批发市场为您的业务备货。我们负责从工厂到您门口的整个过程，这提高了您的业务盈利能力并节省了时间。",
    value:
      "Rakumart ti permette di rifornire la tua attività nel più grande mercato all'ingrosso del mondo. Ci occupiamo di tutto il processo, dalla fabbrica fino alla tua porta, aumentando così la redditività e il tempo a disposizione per la tua attività.",
  },
  {
    key: "全面且简单的中国进口管理",
    value: "Gestione completa e semplice delle importazioni dalla Cina",
  },
  {
    key: "我们负责所有的文件管理、手续和海关流程。",
    value:
      "Ci occupiamo di tutta la gestione documentale, delle pratiche e delle procedure doganali.",
  },
  {
    key: "优化运输和进口成本",
    value: "Ottimizza i costi di spedizione e di importazione",
  },
  {
    key: "我们汇总来自不同供应商的货物，并整合国际运输。",
    value:
      "Raggruppiamo le merci di diversi fornitori e riunifichiamo le spedizioni internazionali.",
  },
  {
    key: "物流基础设施为您的业务提供支持。",
    value: "Infrastruttura logistica per farla fruttare con il tuo business.",
  },
  {
    key: "我们在中国拥有自有仓库供您使用。",
    value: "Abbiamo magazzini propri in Cina a tua disposizione.",
  },
  {
    key: "我们现已覆盖三个大陆，目标是改变与中国相关的商业世界。",
    value:
      "Siamo ora presenti in tre continenti, con l'obiettivo di cambiare il mondo degli affari legati alla Cina.",
  },
  {
    key:
      "目前，Rakumart在三个大陆运营，其关联公司位于大阪（日本）、首尔（韩国）、圣保罗（巴西）、意大利、意大利、香港和杭州（中国）。",
    value:
      "Attualmente, Rakumart opera in tre continenti e le sue società affiliate si trovano a Osaka (Giappone), Seul (Corea del Sud), San Paolo (Brasile), Spagna, Italia, Hong Kong e Hangzhou (Cina).",
  },
  {
    key:
      "我们希望覆盖全球主要语言市场，利用来自中国的B2B数字贸易空间，开拓不同国家的新市场，让更多企业享受Rakumart提供的“包容性数字贸易”带来的优势。",
    value:
      'Desideriamo coprire i principali mercati linguistici globali, sfruttare lo spazio del commercio digitale B2B proveniente dalla Cina, aprire nuovi mercati in diversi paesi e consentire a un numero sempre maggiore di imprese di godere dei vantaggi offerti dal "commercio digitale inclusivo" di Rakumart.',
  },
  // 客服联系页面
  {
    key: "联系方式与客户服务",
    value: "Assistenza Clienti Rakumart",
  },
  {
    key: "我们能帮您什么？",
    value: "Cosa possiamo aiutarti?",
  },
  {
    key: "与我们的团队成员交谈。",
    value: "Parla con un membro del nostro team di agenti.",
  },
  {
    key: "我们将为您提供帮助和建议，协助您完成从中国进口的整个流程。",
    value:
      "Ti aiuteremo e ti consiglieremo durante l'intero processo di importazione dalla Cina.",
  },
  {
    key: "联系代理",
    value: "Contattare un agente",
  },
  {
    key: "访问我们的帮助中心解决疑问。",
    value: "Consulta il nostro centro assistenza per risolvere i dubbi.",
  },
  {
    key: "查阅我们的帮助中心以找到您所需要的解答。",
    value:
      "Visita il nostro centro assistenza per trovare le risposte che cerchi.",
  },
  {
    key: "进入帮助中心",
    value: "Vai al centro assistenza",
  },
  {
    key: "联系方式",
    value: "Metodi di contatto",
  },
  {
    key: "中国中心",
    value: "Cina Centrale",
  },
  {
    key: "中国浙江省义乌市北苑街道春晗路127号2号楼3-6层",
    value:
      "Edificio 2, Piani 3-6, No.127 Chunhan Road, Sottodistretto di Beiyuan, Città di Yiwu, Provincia di Zhejiang, Cina.",
  },
  // ==================== 国际运输页面 ====================
  {
    key: "我们为您全权管理",
    value: "GESTIAMO TUTTO PER TE",
  },
  {
    key: "Rakumart专业的国际运输服务及物流解决方案",
    value:
      "Spedizioni Internazionali: La Soluzione Logistica per il tuo Business",
  },
  {
    key: "通过Rakumart完成物流与运输",
    value: "Logistica e spedizione con Rakumart",
  },
  {
    key:
      "Rakumart为您管理并完成从中国到目的地的整个物流和进口过程。利用Rakumart为您提供的所有资源，彻底改变从中国采购和进口的方式，为您的业务节省时间与成本。",
    value:
      "Rakumart gestisce e realizza per te l'intero processo di logistica e importazione dalla Cina. Sfrutta tutte le risorse che Rakumart mette a tua disposizione per cambiare completamente il modo di acquistare e importare dalla Cina, risparmia tempo e costi per la tua attività.",
  },
  {
    key: "我们的优势",
    value: "I nostri vantaggi",
  },
  {
    key: "门到门运输",
    value: "Spedizione door to door",
  },
  {
    key: "Rakumart为您进口商品，并全程管理运输和手续直至交付。",
    value:
      "Rakumart importa per te e gestisce l'intero processo di spedizione e le pratiche fino alla consegna.",
  },
  {
    key: "成本优化",
    value: "Ottimizzazione dei costi",
  },
  {
    key: "我们将来自不同供应商的货物进行整合，并统一国际运输。",
    value:
      "Raggruppiamo le merci di diversi fornitori e riunifichiamo le spedizioni internazionali.",
  },
  {
    key: "在中国的仓储",
    value: "Stoccaggio in Cina",
  },
  {
    key: "我们在中国拥有自己的仓库，用于管理所有货物的物流。",
    value:
      "Disponiamo di magazzini propri in Cina per la gestione logistica di tutte le merci.",
  },
  {
    key: "质量控制",
    value: "Controllo di qualità",
  },
  {
    key: "我们负责在接收到货物后进行相关的质量检查。",
    value:
      "Ci occupiamo di effettuare i controlli di qualità pertinenti quando riceviamo le merci.",
  },
  {
    key: "个性化服务",
    value: "Servizio personalizzato",
  },
  {
    key: "我们可以根据客户的需求定制服务，完全满足他们的特定要求。",
    value:
      "Possiamo adattarci a qualsiasi esigenza dei nostri clienti che richano servizi su misura.",
  },
  {
    key: "客户服务",
    value: "Assistenza clienti",
  },
  {
    key: "在整个流程中的每一步都有专门的代理人员，从中国开始，并使用意大利语。",
    value:
      "In ogni fase dell'intero processo è presente un agente dedicato, a partire dalla Cina, che utilizza la lingua italiana.",
  },
  {
    key: "工厂",
    value: "Fabbrica",
  },
  {
    key: "运输",
    value: "Trasporto",
  },
  {
    key: "中国仓库",
    value: "Magazzino in Cina",
  },
  {
    key: "中国海关",
    value: "Dogana cinese",
  },
  {
    key: "意大利海关",
    value: "Dogana italiana",
  },
  {
    key: "意大利运输",
    value: "Trasporto in Italia",
  },
  {
    key: "完整的工厂物流服务",
    value: "Servizio logistico completo dalla fabbrica",
  },
  {
    key: "我们将在整个过程中全程陪伴您，从采购一直到交付到您手中。",
    value:
      "Ti accompagneremo durante l'intero processo, dall'acquisto fino alla consegna nelle tue mani.",
  },
  {
    key: "Rakumart提供完整的物流服务管理，从供应商的工厂直到您的收货地址。",
    value:
      "Rakumart offre un servizio completo di gestione logistica, dalla fabbrica del fornitore fino al tuo indirizzo di ricezione.",
  },
  {
    key: "这让我们的客户可以随时了解他们的货物在进口流程中的具体环节。",
    value:
      "Questo permette ai nostri clienti di sapere in ogni momento in quale fase del processo di importazione si trovano le loro merci.",
  },
  {
    key:
      "我们在中国拥有超过70,000平方米的仓库，用于接收、处理和存储货物，直到发运到意大利。",
    value:
      "In Cina disponiamo di oltre 70.000 metri quadrati di magazzini per la ricezione, la lavorazione e lo stoccaggio delle merci, fino alla spedizione in Italia.",
  },
  {
    key: "运输方式",
    value: "Modalità di spedizione",
  },
  {
    key: "最小体积",
    value: "VOLUME MINIMO",
  },
  {
    key: "最大体积",
    value: "VOLUME MASSIMO",
  },
  {
    key: "运输时间*",
    value: "TEMPO DI TRASPORTO*",
  },
  {
    key:
      "*运输时间具体指物流公司将货物从起点运输到目的地所需的时间。因此，「运输时间」不应与「总交货时间」相混淆。这些时间为大致估算，可能会因天气、海关规定等外部因素而有所变化。你可以",
    value:
      "*I tempi di trasporto si riferiscono specificamente al periodo richiesto dalla compagnia logistica per trasportare la merce dal punto di origine al punto di destinazione. Pertanto, il «tempo di trasporto» non deve essere confuso con il «tempo di consegna totale». Questi tempi sono approssimativi e possono variare a seconda di fattori esterni come il clima, le normative doganali, tra gli altri. Puoi ",
  },
  {
    key: "了解更多关于物流与运输的信息。",
    value: "consultare maggiori informazioni su logistica e spedizioni.",
  },
  {
    key:
      "*运输时间具体指物流公司将货物从起点运输到目的地所需的时间。因此，「运输时间」不应与「总交货时间」相混淆。这些时间为大致估算，可能会因天气、海关规定等外部因素而有所变化。你可以点击此处了解更多关于物流与运输的信息。",
    value:
      "*I tempi di trasporto si riferiscono specificamente al periodo richiesto dalla compagnia logistica per trasportare la merce dal punto di origine al punto di destinazione. Pertanto, il «tempo di trasporto» non deve essere confuso con il «tempo di consegna totale». Questi tempi sono approssimativi e possono variare a seconda di fattori esterni come il clima, le normative doganali, tra gli altri. Puoi consultare maggiori informazioni su logistica e spedizioni cliccando qui.",
  },
  {
    key: "你需要估算货物的运输费用吗？",
    value: "Hai bisogno di un preventivo per la spedizione della merce?",
  },
  {
    key: "请联系一位专业代理",
    value: "Mettiti in contatto con un agente esperto",
  },
  {
    key:
      "按照购买步骤操作，或者提供你想要运送的货物信息，以便我们为你提供帮助。",
    value:
      "Segui i passaggi di acquisto oppure fornisci le informazioni sulla merce che desideri spedire, così che possiamo aiutarti.",
  },
  {
    key: "联系专属业务经理获取报价",
    value: "Richiedi un preventivo al tuo consulente commerciale.",
  },
  {
    key: "与代理报价",
    value: "Richiedi un preventivo con un agente",
  },
  {
    key:
      "我们在中国的物流能力创造了竞争优势，使我们的客户因其便利性和成本节约而受益。",
    value:
      "La nostra capacità logistica in Cina crea un vantaggio competitivo di cui i nostri clienti beneficiano per comodità e risparmio",
  },
  {
    key: "提供 24/7 全天候支持，覆盖交付的各个阶段",
    value: "Supporto 24/7 in tutte le fasi di consegna",
  },
  {
    key: "享受优化的运输和进口费用",
    value: "Goditi tariffe di spedizione e di importazione ottimizzate",
  },
  {
    key: "包括仓储、操作和质量控制",
    value: "Stoccaggio, movimentazione e controllo di qualità inclusi",
  },
  {
    key: "从您的控制面板追踪进口",
    value: "Monitoraggio dell'importazione dal tuo Pannello di controllo",
  },
  {
    key: "中国和意大利的物流中心",
    value: "Centri logistici in Cina e in Italia",
  },
  {
    key:
      "我们拥有物流中心，确保货物运输的绝对安全。在这些中心里，我们专业的团队每天执行货物分拣、储存、操作、质量控制等任务。",
    value:
      "Disponiamo di centri logistici che garantiscono la massima sicurezza nel trasporto delle merci. In questi centri, i nostri team specializzati svolgono quotidianamente attività di smistamento, stoccaggio, movimentazione, controllo di qualità delle merci, tra le altre.",
  },
  {
    key:
      "Rakumart的这一业务领域是一个巨大优势，因为我们正在努力出色地覆盖和管理客户的供应链。",
    value:
      "Quest'area operativa di Rakumart rappresenta un grande vantaggio, poiché ci impegniamo a coprire e gestire in modo eccellente la catena di approvvigionamento dei nostri clienti.",
  },
  {
    key: "物流服务包括：",
    value: "I servizi logistici includono:",
  },
  {
    key: "从工厂接收货物",
    value: "Ricezione del carico dalla fabbrica",
  },
  {
    key: "货物存储",
    value: "Stoccaggio delle merci",
  },
  {
    key: "货物处理",
    value: "Movimentazione delle merci",
  },
  {
    key: "生产制造证书",
    value: "Produzione dei certificati di fabbricazione",
  },
  {
    key: "海关清关",
    value: "Sdoganamento",
  },
  {
    key: "其他按需服务",
    value: "Altri servizi su richiesta",
  },
  {
    key: "关于货运与运输的信息：",
    value: "Informazioni su nolo e spedizioni:",
  },
  {
    key: "禁止购买和运输的危险物品",
    value: "Beni proibiti che non possono essere acquistati né trasportati",
  },
  {
    key:
      "危险品是指所有具有以下特性和性质的物品：可能威胁人类生命和健康；可能对环境造成不可挽回的损害；可能对物质物品造成破坏。",
    value:
      "Le merci pericolose sono tutti gli oggetti con caratteristiche e proprietà che possono: minacciare la vita e la salute umana; causare danni irreparabili all'ambiente; causare danni a beni materiali.",
  },
  {
    key:
      "被划归为这类的商品包括：动物及动物制品、植物产品、动物或植物油脂、食品制品、普通金属、精密仪器、武器和弹药、艺术品。",
    value:
      "Le merci sotto questa denominazione sono: animali e prodotti di origine animale, prodotti vegetali, grassi e oli di origine animale o vegetale, preparati alimentari, metalli comuni, strumenti di precisione, armi e munizioni, opere d'arte.",
  },
  {
    key: "国际运输公司的筛选",
    value: "Selezione delle aziende di trasporto internazionale",
  },
  {
    key: "Rakumart 将选择可靠、快捷且成本效益高的国际物流渠道来发送您的货物。",
    value:
      "Rakumart sceglierà canali logistici internazionali affidabili, rapidi ed economicamente competitivi per la spedizione delle tue merci.",
  },
  {
    key: "经过精细的评估，我们会考量运费成本、运输准时性及服务稳定性等因素。",
    value:
      "Dopo un'attenta valutazione, prendiamo in considerazione fattori come il costo del nolo, la puntualità del trasporto e la stabilità del servizio.",
  },
  {
    key: "我们始终保持不断更新，为您在平台上提供最佳的物流合作伙伴和运输路线。",
    value:
      "Siamo sempre in costante aggiornamento, selezionando i migliori partner logistici e le rotte di trasporto da offrirti sulla nostra piattaforma.",
  },
  {
    key: "海关货物清关",
    value: "Sdoganamento delle merci",
  },
  {
    key:
      "货物的海关清关将根据您在申请交付时选择的清关方式（海运、空运或陆运）进行确定。",
    value:
      "Lo sdoganamento delle merci sarà determinato in base al metodo di sdoganamento che sceglierai al momento della richiesta di consegna (via mare, via aerea o via terra).",
  },
  {
    key:
      "我们公司将负责相关的海关清关事宜。如果客户希望自行办理清关手续，也可以选择自行处理。",
    value:
      "La nostra azienda si occuperà delle pratiche di sdoganamento pertinenti. I nostri clienti possono anche scegliere di svolgere le procedure doganali per conto proprio, se lo desiderano.",
  },
  {
    key: "联系一位专家代理",
    value: "Contatta un agente esperto",
  },
  {
    key:
      "您是否正在寻找从中国进口的最佳解决方案？Rakumart就是答案，我们为您处理所有事宜，从购买产品到送达收货地址。请联系一位专业代理，开始享受我们所有的优势吧。",
    value:
      "Stai cercando la migliore soluzione per le tue importazioni dalla Cina? Rakumart è la risposta, noi ci occupiamo di tutto, dall'acquisto del prodotto fino alla ricezione all'indirizzo di consegna. Contatta un agente esperto e inizia a beneficiare di tutti i nostri vantaggi.",
  },
  {
    key: "联系专属顾问",
    value: "Contatta il tuo consulente dedicato",
  },
  {
    key: "联系代理人",
    value: "Contatta l’agente",
  },
  {
    key: "物流过程",
    value: "Processo logistico",
  },
  {
    key: "国际运输阶段",
    value: "Spedizione internazionale",
  },
  {
    key: "空运",
    value: "Aereo",
  },
  {
    key: "陆运",
    value: "Terrestre",
  },
  {
    key: "海运",
    value: "Marittimo",
  },
  {
    key: "铁路货运",
    value: "Ferroviario",
  },
  {
    key: "无最低限制",
    value: "Nessun minimo",
  },
  {
    key: "无最高限制",
    value: "Nessun massimo",
  },
  {
    key: "约10-20天",
    value: "Circa 10-20 giorni",
  },
  {
    key: "约35-45天",
    value: "Circa 35-45 giorni",
  },
  {
    key: "约60-70天",
    value: "Circa 60-70 giorni",
  },
  {
    key: "约45-55天",
    value: "Circa 45-55 giorni",
  },
  {
    key: "运输费用明细",
    value: "Dettaglio dei costi di spedizione",
  },
  {
    key: "运费中的国际运输",
    value: "Spedizione internazionale",
  },
  {
    key: "国际运输至意大利的费用。",
    value: "Costo della spedizione internazionale in Italia.",
  },
  {
    key: "意大利国内物流",
    value: "Logistica in Italia",
  },
  {
    key: "从我们在意大利的仓库分拣并国内运输至最终收货地址的费用。",
    value:
      "Costo del picking e della spedizione nazionale dal nostro magazzino in Italia all'indirizzo di consegna finale.",
  },
  {
    key: "反倾销关税",
    value: "Dazi antidumping",
  },
  {
    key: "在意大利支付货物的海关关税。",
    value: "Pagamento dei dazi doganali della merce in Italia.",
  },
  {
    key: "增值税(IVA)",
    value: "IVA",
  },
  {
    key: "21%税率",
    value: "Imposta del 21%",
  },
  {
    key: "专业商品增值服务",
    value: "Servizi extra professionali",
  },
  {
    key:
      "在Rakumart，你还可以享受其他附加服务，如FBA贴标、产品摄影、ODM定制、翻译等。你有自己的私人品牌吗？太棒了，快联系我们吧！",
    value:
      "Su Rakumart potrai usufruire anche di servizi aggiuntivi come l'etichettatura FBA, la fotografia di prodotto, la personalizzazione ODM, traduzione, ecc. Hai il tuo marchio privato? Perfetto, contattaci!",
  },
  {
    key: "为私人品牌提供定制化 OEM/ODM 服务。",
    value: "Servizi OEM/ODM personalizzati per marchio privato",
  },
  {
    key: "为您的品牌提供定制化 OEM 生产",
    value: "Produzione OEM personalizzata per il tuo brand",
  },
  {
    key:
      "客户提出初步设计方案，我们将委托生产工厂将其实现，从而获得一款完全原创的产品。",
    value:
      "Il cliente presenta un progetto di design preliminare; affideremo lo stabilimento di produzione per realizzarlo, ottenendo così un prodotto completamente originale.",
  },
  {
    key: "由于该流程从工厂采购材料开始，起订量与整体采购量通常会相应提高。",
    value:
      "Poiché il processo richiede l'acquisto di materiali direttamente dalla fabbrica, il quantitativo minimo d'ordine e il volume complessivo di acquisto aumentano normalmente.",
  },
  {
    key: "我们将与制造商确认起订量、单价、交货日期及工厂打样进度。",
    value:
      "Confermeremo con il produttore il MOQ, il prezzo unitario, la data di consegna e l'avanzamento della prototipazione in fabbrica.",
  },
  {
    key: "ODM生产服务",
    value: "Servizio di produzione ODM",
  },
  {
    key:
      "在现有产品上进行定制，添加客户所需的功能或特性，以通过其私人品牌进行销售。",
    value:
      "Personalizzazione su un prodotto esistente aggiungendo le funzionalità o le caratteristiche desiderate dal cliente per distribuirlo sotto la sua marca privata.",
  },
  {
    key: "此过程与上述类似，从工厂采购材料开始，因此生产量会增加。",
    value:
      "Questo processo, come il precedente, inizia con l'acquisto di materiali da parte della fabbrica, pertanto il volume di produzione aumenta.",
  },
  {
    key: "包装、标签和宣传册",
    value: "Packaging, etichette e opuscoli",
  },
  {
    key: "生产个性化包装、标签、包裹、宣传材料和您的私人品牌标志性元素。",
    value:
      "Produzione di packaging personalizzato, etichette, confezioni, materiale informativo ed elementi distintivi per il tuo marchio privato.",
  },
  {
    key:
      "生产取决于所需的尺寸、颜色和材料类型。您需要提供所有品牌元素和信息，以便我们为您出具报价。",
    value:
      "La produzione dipende dalle dimensioni, dal colore e dal tipo di materiale richiesto. Dovrai fornire tutti gli elementi e le informazioni del tuo marchio per consentirci di preparare un preventivo.",
  },
  {
    key: "请与我们的代理商咨询定制元素在产品组合中的组装和调整成本。",
    value:
      "Consulta con i nostri agenti i costi di montaggio e adattamento degli elementi personalizzati sull'insieme dei prodotti.",
  },
  {
    key: "如需更多信息，请联系业务代理。",
    value: "Per ulteriori informazioni, contattare il consulente commerciale.",
  },
  {
    key: "为您的产品提供额外服务",
    value: "Servizi aggiuntivi per i tuoi prodotti",
  },
  {
    key: "产品摄影",
    value: "Fotografia di prodotto",
  },
  {
    key: "专业摄影服务，用于销售，无论商品的种类或复杂程度。",
    value:
      "Fotografia professionale per la vendita indipendentemente dal tipo di articolo o dalla complessità.",
  },
  {
    key: "SKU标签",
    value: "Etichettatura SKU",
  },
  {
    key: "带有SKU编码的标签放置",
    value: "Applicazione di etichette con codice SKU",
  },
  {
    key: "条形码标签",
    value: "Etichettatura con codice a barre",
  },
  {
    key: "包括更换OPP塑料袋",
    value: "Include la sostituzione del sacchetto di plastica, PP",
  },
  {
    key: "更换OPP塑料袋",
    value: "Cambio sacchetto di plastica, PP",
  },
  {
    key: "大件物品需单独报价",
    value: "Gli articoli voluminosi vengono quotati separatamente",
  },
  {
    key: "双面打印宣传页",
    value: "Volantino stampato fronte-retro",
  },
  {
    key: "默认使用A4尺寸纸张，如需其他纸张类型或小册子打印，可根据要求提供。",
    value:
      "Si utilizza di default carta formato A4; se sono necessari altri tipi di carta o la stampa di opuscoli, è possibile fornirli su richiesta.",
  },
  {
    key: "织物标签缝制",
    value: "Cucitura di etichette in tessuto",
  },
  {
    key: "在纺织品如T恤、衬衫等上缝制带有您品牌的个性化标签。",
    value:
      "Cucitura di etichette personalizzate con il tuo marchio su tessili come T-shirt, camicie, ecc.",
  },
  {
    key: "去除布料标签",
    value: "Rimozione di etichette in tessuto",
  },
  {
    key: "我们去除了某些纺织品可能自工厂附带的布料标签。",
    value:
      "Rimuoviamo le etichette in tessuto che alcuni prodotti tessili possono avere applicate dalla fabbrica.",
  },
  {
    key: "悬挂标签的放置【衣服吊牌】",
    value: "Posizionamento di etichette pendenti [cartellino dei vestiti]",
  },
  {
    key: "在您需要的产品上悬挂带有您品牌的标签。",
    value:
      "Applicazione di etichette con il tuo marchio sui prodotti di cui hai bisogno.",
  },
  {
    key: "去除吊牌",
    value: "Rimozione dei cartellini",
  },
  {
    key: "去除你所需产品上的工厂吊牌。",
    value:
      "Rimozione dei cartellini di fabbrica dai prodotti di cui hai bisogno.",
  },
  {
    key: "组合包装",
    value: "Confezionamento combinato",
  },
  {
    key: "对于超过 4 件商品的配套增值服务，需另行询价",
    value:
      "Per servizi accessori riguardanti più di 4 articoli, è necessario richiedere un preventivo dedicato.",
  },
  {
    key: "气泡膜包装保护服务",
    value: "Servizio di protezione con imballaggio a bolle.",
  },
  {
    key: "大尺寸/重型货物需申请特殊报价",
    value:
      "Per articoli di grandi dimensioni o pesanti è richiesto un preventivo dedicato.",
  },
  {
    key: "您需要为您的产品定制特殊服务吗？",
    value: "Ha bisogno di servizi speciali per i suoi prodotti?",
  },
  {
    key:
      "请告知我们您所需的服务类型及对应的产品，我们将为您提供全方位的定制化方案。",
    value:
      "Ci indichi i servizi di cui ha bisogno e i relativi prodotti; le forniremo tutte le opzioni possibili.",
  },
  // ==================== 运费价格试算页面 ====================
  {
    key: "全流程一站式管家服务",
    value: 'Servizio di gestione completa "chiavi in mano"',
  },
  {
    key: "Rakumart 跨境物流收费透明说明",
    value: "Panoramica trasparente delle tariffe di spedizione Rakumart",
  },
  {
    key: "Rakumart 提供全链路托管，从源头采购到目的地清关，专业执行",
    value:
      "Rakumart offre una gestione completa del processo logistico, dall'approvvigionamento in Cina allo sdoganamento finale",
  },
  {
    key: "携手 Rakumart，重塑跨境采购与进口体验",
    value:
      "Collabora con Rakumart per trasformare la tua esperienza di acquisto e importazione",
  },
  {
    key: "高效优化供应链，显著降低综合成本",
    value:
      "Ottimizzazione efficiente della catena di approvvigionamento per una riduzione significativa dei costi",
  },
  {
    key: "Rakumart跨境物流服务概览",
    value: "Panoramica dei servizi logistici Rakumart",
  },
  {
    key:
      "运输时间（Transit Time）仅指货物从起运地至目的地的实际在途运输时长。此数据仅供参考，实际送达时间可能受天气变化、海关查验、旺季物流与仓储压力等不可控因素影响。详情请参阅",
    value:
      "Il tempo di transito (Transit Time) indica esclusivamente la durata del trasporto effettivo dall'origine alla destinazione. Questa stima è puramente indicativa, poiché la consegna effettiva può subire variazioni dovute a fattori indipendenti dalla nostra volontà, quali condizioni meteorologiche avverse, controlli doganali, picchi stagionali o pressione logistica e di stoccaggio. Per ulteriori dettagli, consultare la ",
  },
  {
    key: "《Rakumart 物流运输指南》",
    value: '"Guida al trasporto logistico Rakumart"',
  },
  {
    key: "。",
    value: ".",
  },
  {
    key: "物流运费估算",
    value: "Stima costi spedizione",
  },
  {
    key: "实际重量",
    value: "Peso reale",
  },
  {
    key: "箱子数量",
    value: "Numero di scatole",
  },
  {
    key: "总重量",
    value: "Peso totale",
  },
  {
    key: "货运方式",
    value: "Metodo di spedizione",
  },
  {
    key: "类别",
    value: "Categoria",
  },
  {
    key: "可计费重量",
    value: "Peso fatturabile",
  },
  {
    key: "国际运费(¥)",
    value: "Spedizione internazionale (¥)",
  },
  {
    key: "国际运费(€)",
    value: "Spedizione internazionale (€)",
  },
  {
    key: "时效",
    value: "Tempi",
  },
  {
    key: "物流费用说明",
    value: "Spiegazione dei costi logistici",
  },
  {
    key: "重量",
    value: "Peso",
  },
  {
    key: "费用",
    value: "Costo",
  },
  {
    key: "最后更新日期",
    value: "Data ultimo aggiornamento",
  },
  {
    key: "交货期",
    value: "Plazo",
  },
  {
    key: "介于",
    value: "Tra",
  },
  {
    key: "联系专业代理",
    value: "Contatta un agente esperto",
  },
  {
    key:
      "您是否正在寻找从中国进口的最佳解决方案？Rakumart是您的理想选择。我们负责从产品采购到送达收货地址的所有流程。立即联系专业代理，享受我们的全方位服务。",
    value:
      "Stai cercando la soluzione migliore per le tue importazioni dalla Cina? Rakumart è la soluzione ideale. Ci occupiamo di tutto noi, dall'acquisto del prodotto fino alla consegna al tuo indirizzo. Contatta un agente esperto e inizia a godere dei nostri servizi completi.",
  },
  // ==================== 佣金页面 ====================
  {
    key: "RAKUMART 的佣金",
    value: "COMMISSIONI DI RAKUMART",
  },
  {
    key: "Rakumart会员等级和佣金费",
    value: "Commissioni e Livelli Rakumart",
  },
  {
    key: "增加采购量，降低佣金支付",
    value: "Aumenta il volume di acquisto e paga meno commissioni",
  },
  {
    key: "佣金百分比将根据您所有已付款订单中商品的累计金额来确定。",
    value:
      "La percentuale di commissione verrà determinata in base all'importo cumulativo dei prodotti di tutti i tuoi ordini già pagati.",
  },
  {
    key:
      "例如，如果你的商品采购额超过40,000€，后续订单的佣金率将降至4%，请查看下表了解你的采购对应的百分比：",
    value:
      "Per esempio, se il tuo volume di acquisto in prodotti supera i 40.000€, la percentuale di commissione passerà al 4% per i prossimi ordini. Consulta la tabella seguente per vedere quale percentuale corrisponde al tuo acquisto:",
  },
  {
    key: "透明定价、阶梯佣金、成本优化",
    value: "Prezzi trasparenti, commissioni graduate, ottimizzazione dei costi",
  },
  {
    key:
      "以较低成本享受 Rakumart 的所有优势。透明且分级的佣金体系，助力您的业务增长。",
    value:
      "Approfitta di tutti i vantaggi di Rakumart con costi contenuti. Commissioni trasparenti e strutturate per supportare la crescita della tua attività.",
  },
  {
    key: "有任何疑问吗？请联系专业代理",
    value: "Hai qualche dubbio? Contatta un agente esperto",
  },
  {
    key:
      "您是否正在寻找从中国进口的最佳解决方案？Rakumart就是答案，我们负责从产品购买到送达指定地址的整个过程。联系专业代理，开始享受我们的诸多优势吧。",
    value:
      "Stai cercando la soluzione migliore per le tue importazioni dalla Cina? Rakumart è la risposta, noi ci occupiamo di tutto, dall'acquisto del prodotto fino alla ricezione all'indirizzo di consegna. Contatta un agente esperto e inizia a beneficiare di tutti i nostri vantaggi.",
  },
  // ==================== 照片服务页面 ====================
  {
    key: "专业的商品摄影服务",
    value: "Servizio di fotografia prodotti",
  },
  {
    key: "摄影服务",
    value: "Servizio fotografico",
  },
  {
    key:
      "我们深知在线销售需要专业的图像来确保买家做出购买决定，这与实体店购物可以亲手感受产品质量有所不同。",
    value:
      "Siamo consapevoli che la vendita online richiede un'immagine professionale per garantire la decisione d'acquisto da parte del compratore, a differenza degli acquisti fisici in cui è possibile apprezzare la qualità del prodotto tra le proprie mani.",
  },
  {
    key:
      "我们提供专业摄影服务，为您提供最佳商品图片，无论商品类型或复杂程度如何。",
    value:
      "Disponiamo di un servizio fotografico professionale per offrirvi le migliori immagini per le vostre vendite, indipendentemente dal tipo di articolo o dalla complessità.",
  },
  {
    key: "成本 -（每产品）",
    value: "Costo - (per prodotto)",
  },
  {
    key: "基础产品摄影费用：",
    value: "Tariffa per la fotografia di prodotti di base:",
  },
  {
    key: "元/件",
    value: "yuan / pezzo",
  },
  {
    key: "免费服务",
    value: "Servizi gratuiti",
  },
  {
    key: "1、模特人体模型",
    value: "1. Manichino modello",
  },
  {
    key:
      "有许多物品，如衣服，仅凭平面照片很难了解其尺寸和整体感觉。使用模特人体模型可以轻松展示诸如西装和背包等物品的尺寸和触感。",
    value:
      "Ci sono molti articoli, come i capi d'abbigliamento, per i quali è difficile farsi un'idea delle dimensioni e della sensazione generale a partire da una fotografia piatta. L'uso di manichini ci permette di mostrare facilmente le dimensioni e il tatto di articoli come completi e zaini.",
  },
  {
    key: "2、熨烫服务",
    value: "2. Servizio di stiratura",
  },
  {
    key: "拍摄完成后，我们可以熨烫衣物并消除可能存在的褶皱。",
    value:
      "Una volta effettuate le fotografie, possiamo stirare i capi ed eliminare le eventuali pieghe.",
  },
  {
    key: "反光处理",
    value: "Trattamento dei riflessi",
  },
  {
    key:
      "珠宝和其他产品在拍摄过程中可能会出现反射。我们将免费修改由于反射造成的光斑。",
    value:
      "È probabile che i gioielli e altri prodotti presentino riflessi durante la sessione fotografica. Modificheremo gratuitamente i bagliori che si verificano.",
  },
  {
    key: "4.白色背景处理",
    value: "4. Elaborazione dello sfondo bianco",
  },
  {
    key:
      "我们为在线销售准备了所有带白色背景的图片，如果您需要任何变动，请留言。",
    value:
      "Prepariamo tutte le immagini con uno sfondo bianco per la vendita online, se desideri qualche variazione ti preghiamo di lasciare un commento.",
  },
  {
    key: "5、照片名称",
    value: "5. Nome della foto",
  },
  {
    key: "我们将依据产品信息逐一为物品命名，以避免错误。",
    value:
      "Nomineremo gli articoli uno per uno in base alle informazioni del prodotto, per evitare errori.",
  },
  {
    key: "6、添加水印",
    value: "6. Aggiunta del logo",
  },
  {
    key:
      "如果你愿意，我们可以免费在图片中添加水印，这样如果你将图片上传到网上，就不会被盗图。",
    value:
      "Se lo desideri, possiamo aggiungere gratuitamente un logo alle immagini affinché non ti rubino la foto quando la carichi su Internet.",
  },
  {
    key: "收费服务",
    value: "Servizi a pagamento",
  },
  {
    key:
      "如果您有其他关于照片的需求，例如搭配的包装、套装、模特等，请与我们联系。",
    value:
      "Contattaci se hai qualche altra richiesta di fotografie, come imballaggi coordinati, set, modelli, ecc.",
  },
  {
    key: "Rakumart用户指南",
    value: "Guida per gli utenti Rakumart",
  },
  {
    key: "订单模式",
    value: "Modalità ordine",
  },
  {
    key: "订单默认模式",
    value: "Modalità ordine predefinita",
  },
  {
    key: "DAP模式自税",
    value: "DAP (EORI cliente)",
  },
  {
    key: "普通订单",
    value: "Ordine standard",
  },
  {
    key:
      "DAP（客户EORI清关模式）：RAKUMART全程负责运输至指定目的地。清关阶段将调用您的EORI号，并同步提供欧盟标准SAD/DUA清关凭证。清关产生的关税、VAT等相关税费需由客户自行依法缴纳。",
    value:
      "DAP (Modalità di sdoganamento con EORI del cliente): RAKUMART gestisce l'intero processo di trasporto fino alla destinazione finale. Lo sdoganamento avverrà utilizzando il Suo numero EORI, e provvederemo a fornirLe la documentazione doganale conforme (SAD/DUA). Tutti i dazi doganali, l'IVA e gli eventuali oneri relativi alla procedura di sdoganamento sono a Suo carico.",
  },
  {
    key:
      "标准订单模式（RAKUMART代清关）：采用RAKUMART税号进行清关，实现“中国仓到最终目的地”的一站式闭环服务。我们将为您提供包含RAKUMART税号的合规商业发票，确保货物清关及后续税务合规。",
    value:
      'Ordine standard (Servizio di sdoganamento RAKUMART): Lo sdoganamento viene eseguito tramite la nostra partita IVA, garantendo un servizio "chiavi in mano" dalla Cina fino alla Sua sede. Le verrà emessa una fattura conforme contenente il numero di partita IVA di RAKUMART, a tutela della conformità fiscale della Sua operazione.',
  },
  {
    key: "请选择后续订单模式！",
    value: "Seleziona la modalità ordine!",
  },
  {
    key: "选择完成后，后续可以在进口方资料界面修改默认订单模式！",
    value:
      "Dopo la selezione, potrai modificare la modalità ordine predefinita nella sezione Dettagli dell'importatore!",
  },
  {
    key: "普通模式",
    value: "Ordine standard",
  },
  {
    key: "DAP自税",
    value: "DAP (EORI cliente)",
  },
  {
    key: "普通",
    value: "Ordine standard",
  },
  {
    key: "金额",
    value: "Importo",
  },
  {
    key:
      "1. [单品费用]该明细表详细计算了各商品采用不同运输方式运抵目的地的成本。(Rakumart负责全程清关及配送。)",
    value:
      "1. [Costo per articolo] Il foglio di calcolo calcola in dettaglio i costi di spedizione per ogni articolo, in base ai diversi metodi di trasporto fino alla destinazione finale. (Rakumart si occupa dello sdoganamento e della consegna finale.)",
  },
  {
    key:
      "1. [单品费用]该明细表详细计算了各商品采用不同运输方式运抵目的地的成本。（Rakumart 负责全程清关及派送。）",
    value:
      "1. [Costo per articolo] Il foglio di calcolo calcola in dettaglio i costi di spedizione per ogni articolo, in base ai diversi metodi di trasporto fino alla destinazione finale. (Rakumart gestisce lo sdoganamento e la consegna al vostro indirizzo.)",
  },
  {
    key:
      "2. [更多信息]此外，表格列明了供应商提供的各商品尺寸和重量，便于您掌握订单详情。",
    value:
      "2. [Maggiori informazioni] Inoltre, il file riporta dimensioni e peso di ciascun articolo forniti dai fornitori, facilitando la consultazione dei dettagli dell'ordine.",
  },
  {
    key: "3. 点击按钮即可下载明细表。",
    value: "3. Cliccare sul pulsante per scaricare il foglio di calcolo.",
  },
  //---------------------------------这些是可能用到的语言，先保留着---------------------------------
  ...langMaby,

  //------------------------------------------------------------------------
];

let fanyi = (value) => {
  if (store.state.fanyi == true) {
    return value;
  }

  for (let i = 0; i < langs.length; i++) {
    if (langs[i].key == value) {
      return langs[i].value ?? langs[i].key;
    }
  }
  return value;
};
export default fanyi;
